import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { usePrefs } from '../hooks/usePrefs';

const API = process.env.REACT_APP_API_URL || '';
const ax  = axios.create({ baseURL: API, withCredentials: true });

const RECO_MAP = [
  { match: 'Aucun site web',     action: 'Créer un site web professionnel',          service: 'Site vitrine complet — à partir de 1 200$',       icon: '🌐', gain: 35 },
  { match: 'Site sans HTTPS',    action: 'Installer un certificat SSL (HTTPS)',       service: 'Migration sécurisée + certificat SSL',             icon: '🔒', gain: 12 },
  { match: 'Aucun avis Google',  action: "Lancer une campagne de collecte d'avis",   service: 'Stratégie réputation Google — SMS/email clients',  icon: '⭐', gain: 20 },
  { match: 'avis seulement',     action: 'Augmenter les avis Google',                service: 'Stratégie réputation Google — SMS/email clients',  icon: '⭐', gain: 15 },
  { match: "Peu d'avis",         action: 'Booster le nombre d\'avis Google',         service: 'Stratégie réputation Google',                      icon: '⭐', gain: 8  },
  { match: 'faible',             action: 'Améliorer la réputation en ligne',          service: 'Gestion réputation + réponses aux avis',           icon: '📈', gain: 10 },
  { match: 'Aucune photo',       action: 'Ajouter des photos professionnelles',      service: 'Séance photo / création de contenu visuel',        icon: '📸', gain: 10 },
  { match: 'photo(s) seulement', action: 'Compléter la galerie photos Google',       service: 'Contenu visuel professionnel',                     icon: '📸', gain: 5  },
  { match: 'Pas de téléphone',   action: 'Compléter la fiche Google Business',       service: 'Optimisation fiche Google Business',               icon: '📞', gain: 5  },
  { match: "Pas d'horaires",     action: "Ajouter les horaires d'ouverture",         service: 'Optimisation fiche Google Business',               icon: '🕐', gain: 5  },
];

const CATEGORIES = [
  { label: 'Restaurant',    q: 'restaurant' },
  { label: 'Bar / Café',    q: 'bar café' },
  { label: 'Plombier',      q: 'plombier' },
  { label: 'Électricien',   q: 'électricien' },
  { label: 'Coiffeur',      q: 'salon coiffure' },
  { label: 'Dentiste',      q: 'dentiste' },
  { label: 'Médecin',       q: 'médecin clinique' },
  { label: 'Garage Auto',   q: 'garage automobile' },
  { label: 'Comptable',     q: 'comptable' },
  { label: 'Avocat',        q: 'cabinet avocat' },
  { label: 'Boutique',      q: 'boutique commerce' },
  { label: 'Hôtel',         q: 'hôtel hébergement' },
  { label: 'Esthétique',    q: 'salon esthétique spa' },
  { label: 'Construction',  q: 'entrepreneur construction' },
  { label: 'Photographe',   q: 'photographe studio' },
  { label: 'Nettoyage',     q: 'entretien nettoyage' },
  { label: 'Gym / Fitness', q: 'gym fitness entrainement' },
  { label: 'Traiteur',      q: 'traiteur événement' },
];

const TYPE_MAP = {
  restaurant:'Restaurant', cafe:'Café', bar:'Bar', hair_care:'Coiffure',
  beauty_salon:'Beauté', spa:'Spa', dentist:'Dentiste', doctor:'Médecin',
  lawyer:'Avocat', accounting:'Comptable', car_repair:'Garage',
  plumber:'Plombier', electrician:'Électricien', lodging:'Hébergement',
  hotel:'Hôtel', store:'Boutique', gym:'Gym', florist:'Fleuriste',
  bakery:'Boulangerie', pharmacy:'Pharmacie',
  real_estate_agency:'Immobilier', photographer:'Photographe',
  general_contractor:'Construction', roofing_contractor:'Toiture',
  moving_company:'Déménagement', laundry:'Nettoyage',
};

// STATUS_LIST chargé depuis les prefs — voir plus bas dans le composant

// Bas score = faible présence = CHAUD (besoin d'Ucreative)
// Haut score = forte présence = ÉTABLI (pas besoin)
function scoreStyle(s) {
  if (s <= 30) return { c:'#f87171', bg:'rgba(248,113,113,0.1)', bd:'rgba(248,113,113,0.3)', label:'CHAUD' };
  if (s <= 60) return { c:'#fbbf24', bg:'rgba(251,191,36,0.1)',  bd:'rgba(251,191,36,0.3)',  label:'TIÈDE' };
  return             { c:'#4ade80', bg:'rgba(74,222,128,0.1)',   bd:'rgba(74,222,128,0.3)',   label:'ÉTABLI' };
}

function typeLabel(types) {
  for (const t of types) if (TYPE_MAP[t]) return TYPE_MAP[t];
  return types[0]?.replace(/_/g, ' ') || '';
}

function ScoreRing({ score }) {
  const { c } = scoreStyle(score);
  return (
    <div style={{ width:68, height:68, borderRadius:'50%', flexShrink:0, position:'relative',
      background:`conic-gradient(${c} ${score * 3.6}deg, #1c1c1c ${score * 3.6}deg)` }}>
      <div style={{ position:'absolute', inset:6, borderRadius:'50%', background:'#0d0d10',
        display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column' }}>
        <span style={{ fontSize:'1.05rem', fontWeight:900, color:c, lineHeight:1 }}>{score}</span>
        <span style={{ fontSize:'0.45rem', color:c+'88', fontWeight:700, letterSpacing:'0.05em' }}>/100</span>
      </div>
    </div>
  );
}

export default function ProspectionSection() {
  const { prefs } = usePrefs();
  const STATUS_LIST = prefs.pipelineStages;
  const [viewTab,  setViewTab]  = useState('finder'); // 'finder' | 'pipeline'
  const [savedLeads,      setSavedLeads]      = useState([]);
  const [pipelineLoading, setPipelineLoading] = useState(false);
  const [pipelineFilter,  setPipelineFilter]  = useState('all');
  const [editNoteId,  setEditNoteId]  = useState(null);
  const [noteDraft,   setNoteDraft]   = useState('');
  const [notesSaved,  setNotesSaved]  = useState({});
  const [mode,     setMode]     = useState('category'); // 'category' | 'general'
  const [query,    setQuery]    = useState('');
  const [location, setLocation] = useState(prefs.defaultLocation || 'Montréal, QC');
  const [radius,   setRadius]   = useState(5000);
  const [noWebsite,setNoWebsite]= useState(false);
  const [results,  setResults]  = useState([]);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState(null);
  const [maxScore, setMaxScore] = useState(prefs.defaultMaxScore ?? 100);
  const [crmAdded,      setCrmAdded]      = useState(new Set());
  const [copied,        setCopied]        = useState(null);
  const [emails,        setEmails]        = useState({});
  const [emailLoading,  setEmailLoading]  = useState(new Set());
  const [showPlan,      setShowPlan]      = useState(new Set());
  const [techs,        setTechs]         = useState({});
  const [techLoading,  setTechLoading]   = useState(new Set());
  const [showSecurity,   setShowSecurity]   = useState(new Set());
  const [auditEmail,     setAuditEmail]     = useState({});
  const [auditSending,   setAuditSending]   = useState(new Set());
  const [auditSent,      setAuditSent]      = useState(new Set());
  const [showAuditInput, setShowAuditInput] = useState(new Set());
  const [pitches,      setPitches]       = useState({});
  const [pitchLoading, setPitchLoading]  = useState(new Set());
  const [showPitch,    setShowPitch]     = useState(new Set());
  const [showGoogleReport, setShowGoogleReport] = useState(new Set());
  const [proposals,        setProposals]        = useState({});
  const [proposalLoading,  setProposalLoading]  = useState(new Set());
  const [showProposal,     setShowProposal]     = useState(new Set());
  const [leadStatuses, setLeadStatuses]  = useState({});

  useEffect(() => {
    ax.get('/api/leads').then(({ data }) => {
      const statuses = {}, savedPitches = {}, savedTechs = {}, savedAuditSent = new Set();
      data.forEach(l => {
        if (l.pipelineStatus) statuses[l.id]   = l.pipelineStatus;
        if (l.pitch)          savedPitches[l.id] = l.pitch;
        if (l.tech)           savedTechs[l.id]   = l.tech;
        if (l.auditSentTo)    savedAuditSent.add(l.id);
      });
      setLeadStatuses(statuses);
      setPitches(savedPitches);
      setTechs(savedTechs);
      setAuditSent(savedAuditSent);
    }).catch(() => {
      try { setLeadStatuses(JSON.parse(localStorage.getItem('lead_statuses') || '{}')); } catch {}
    });
  }, []);

  const filtered  = results.filter(r => r.score <= maxScore);
  const hot       = results.filter(r => r.score <= 30).length;
  const warm      = results.filter(r => r.score > 30 && r.score <= 60).length;

  async function search() {
    if (!query.trim()) return;
    setLoading(true); setError(null); setResults([]);
    try {
      const { data } = await ax.post('/api/prospection/search', { query, location });
      setResults(data);
    } catch (e) {
      setError(e.response?.data);
    } finally { setLoading(false); }
  }

  async function sweep() {
    if (!location.trim()) return;
    setLoading(true); setError(null); setResults([]);
    try {
      const { data } = await ax.post('/api/prospection/sweep', { location, radius, noWebsite });
      setResults(data);
    } catch (e) {
      setError(e.response?.data);
    } finally { setLoading(false); }
  }

  async function addToCRM(lead) {
    try {
      await ax.post('/api/clients', {
        name:    lead.name,
        phone:   lead.phone || '',
        email:   '',
        company: lead.name,
        project: 'Site web',
        budget:  '',
        status:  'prospect',
        notes:   `🎯 Lead Google Business\nAdresse: ${lead.address}\nSite actuel: ${lead.website || 'Aucun site web'}\nScore Ucreative: ${lead.score}/100\n\nOpportunités: ${lead.reasons.map(r => r.text).join(' • ')}`,
      });
      setCrmAdded(prev => new Set([...prev, lead.id]));
    } catch (e) {
      alert('Erreur CRM : ' + (e.response?.data?.error || e.message));
    }
  }

  function exportCSV() {
    const header = ['Nom','Adresse','Téléphone','Site web','Note Google','Avis','Photos','Score /100','Opportunités'];
    const rows = results.map(r => [
      r.name, r.address, r.phone || '', r.website || '',
      r.rating ?? 'N/A', r.reviewCount, r.photoCount, r.score,
      r.reasons.map(x => x.text).join(' | '),
    ]);
    const csv = [header, ...rows]
      .map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(','))
      .join('\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' }));
    a.download = `leads-${location.replace(/[^a-z0-9]/gi,'-')}-${Date.now()}.csv`;
    a.click();
  }

  function copyPhone(lead) {
    navigator.clipboard?.writeText(lead.phone);
    setCopied(lead.id);
    setTimeout(() => setCopied(null), 2000);
  }

  async function findEmail(lead) {
    if (!lead.website || emailLoading.has(lead.id)) return;
    setEmailLoading(prev => new Set([...prev, lead.id]));
    try {
      const { data } = await ax.post('/api/prospection/find-email', { website: lead.website });
      setEmails(prev => ({ ...prev, [lead.id]: data.emails }));
    } catch {
      setEmails(prev => ({ ...prev, [lead.id]: [] }));
    } finally {
      setEmailLoading(prev => { const s = new Set(prev); s.delete(lead.id); return s; });
    }
  }

  function copyEmail(email) {
    navigator.clipboard?.writeText(email);
    setCopied('email-' + email);
    setTimeout(() => setCopied(null), 2000);
  }

  async function loadPipeline() {
    setPipelineLoading(true);
    try {
      const { data } = await ax.get('/api/leads');
      setSavedLeads(data.sort((a, b) => (b.updatedAt || '') > (a.updatedAt || '') ? 1 : -1));
      const notes = {};
      data.forEach(l => { if (l.notes) notes[l.id] = l.notes; });
      setNotesSaved(notes);
    } catch {}
    finally { setPipelineLoading(false); }
  }

  async function deletePipelineLead(leadId) {
    try {
      await ax.delete(`/api/leads/${leadId}`);
      setSavedLeads(prev => prev.filter(l => l.id !== leadId));
    } catch (e) {
      alert('Erreur lors de la suppression');
    }
  }

  async function saveNote(leadId) {
    await ax.post('/api/leads', { placeId: leadId, notes: noteDraft });
    setNotesSaved(prev => ({ ...prev, [leadId]: noteDraft }));
    setSavedLeads(prev => prev.map(l => l.id === leadId ? { ...l, notes: noteDraft } : l));
    setEditNoteId(null);
  }

  function saveLead(lead, extra = {}) {
    ax.post('/api/leads', {
      placeId: lead.id,
      name: lead.name, address: lead.address,
      phone: lead.phone || '', website: lead.website || '',
      score: lead.score, rating: lead.rating ?? null,
      reviewCount: lead.reviewCount, photoCount: lead.photoCount,
      hasHours: lead.hasHours, mapsUrl: lead.mapsUrl,
      ...extra,
    }).catch(() => {});
  }

  async function detectTech(lead) {
    if (!lead.website || techLoading.has(lead.id)) return;
    setTechLoading(prev => new Set([...prev, lead.id]));
    try {
      const { data } = await ax.post('/api/prospection/detect-tech', { website: lead.website });
      setTechs(prev => ({ ...prev, [lead.id]: data }));
      saveLead(lead, { tech: data });
    } catch {
      setTechs(prev => ({ ...prev, [lead.id]: null }));
    } finally {
      setTechLoading(prev => { const s = new Set(prev); s.delete(lead.id); return s; });
    }
  }

  async function generatePitch(lead) {
    if (pitchLoading.has(lead.id)) return;
    setPitchLoading(prev => new Set([...prev, lead.id]));
    try {
      const { data } = await ax.post('/api/prospection/generate-pitch', {
        lead,
        agencyInfo: { name: prefs.agencyName, phone: prefs.agencyPhone, website: prefs.agencyWebsite },
      });
      setPitches(prev => ({ ...prev, [lead.id]: data.pitch }));
      setShowPitch(prev => new Set([...prev, lead.id]));
      saveLead(lead, { pitch: data.pitch });
    } catch (e) {
      setPitches(prev => ({ ...prev, [lead.id]: '⚠️ Erreur : ' + (e.response?.data?.error || e.message) }));
      setShowPitch(prev => new Set([...prev, lead.id]));
    } finally {
      setPitchLoading(prev => { const s = new Set(prev); s.delete(lead.id); return s; });
    }
  }

  async function generateProposal(lead) {
    if (proposalLoading.has(lead.id)) return;
    setProposalLoading(prev => new Set([...prev, lead.id]));
    try {
      const { data } = await ax.post('/api/proposals/generate', {
        lead,
        tech: techs[lead.id] || null,
        seo:  techs[lead.id]?.seo || null,
        agencyInfo: {
          name:    prefs.agencyName,
          tagline: prefs.agencyTagline,
          city:    prefs.agencyCity,
          phone:   prefs.agencyPhone,
          website: prefs.agencyWebsite,
        },
      });
      setProposals(prev => ({ ...prev, [lead.id]: data.proposal }));
      setShowProposal(prev => new Set([...prev, lead.id]));
    } catch (e) {
      alert('Erreur Devis IA : ' + (e.response?.data?.error || e.message));
    } finally {
      setProposalLoading(prev => { const s = new Set(prev); s.delete(lead.id); return s; });
    }
  }

  async function sendAudit(lead) {
    const email = auditEmail[lead.id];
    if (!email?.trim()) return;
    setAuditSending(prev => new Set([...prev, lead.id]));
    try {
      await ax.post('/api/prospection/send-audit', {
        lead,
        failles:    techs[lead.id]?.failles || [],
        tech:       techs[lead.id] || {},
        toEmail:    email.trim(),
        agencyInfo: {
          name:    prefs.agencyName,
          email:   prefs.agencyEmail,
          phone:   prefs.agencyPhone,
          website: prefs.agencyWebsite,
          tagline: prefs.agencyTagline,
          accent:  prefs.accentColor,
          footer:  prefs.emailFooter,
          sender:  prefs.senderName,
        },
      });
      setAuditSent(prev => new Set([...prev, lead.id]));
      setShowAuditInput(prev => { const s = new Set(prev); s.delete(lead.id); return s; });
      saveLead(lead, { auditSentTo: email.trim() });
    } catch (e) {
      alert('Erreur envoi : ' + (e.response?.data?.error || e.message));
    } finally {
      setAuditSending(prev => { const s = new Set(prev); s.delete(lead.id); return s; });
    }
  }

  function updateLeadStatus(lead, status) {
    setLeadStatuses(prev => ({ ...prev, [lead.id]: status }));
    saveLead(lead, { pipelineStatus: status });
  }

  function exportGoogleReportPDF(lead, items, score) {
    const agency = prefs.agencyName || 'Ucreative Inc.';
    const priorityColor = { critique: ['#fee2e2','#dc2626'], élevée: ['#fef3c7','#d97706'], moyenne: ['#dbeafe','#2563eb'] };
    const scoreColor = score >= 70 ? '#16a34a' : score >= 40 ? '#d97706' : '#dc2626';
    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8">
<title>Audit Fiche Google — ${lead.name}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:-apple-system,Arial,sans-serif;max-width:780px;margin:0 auto;padding:48px 40px;color:#111;line-height:1.5}
  .header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:32px;padding-bottom:24px;border-bottom:2px solid #e5e7eb}
  .score-num{font-size:52px;font-weight:900;color:${scoreColor};line-height:1}
  h1{font-size:20px;font-weight:800;margin-bottom:4px}
  .sub{color:#666;font-size:13px}
  .section-title{font-size:13px;font-weight:700;color:#888;text-transform:uppercase;letter-spacing:.08em;margin:24px 0 12px}
  .item{border-left:4px solid #e5e7eb;padding:12px 16px;margin:10px 0;border-radius:0 8px 8px 0;background:#fafafa}
  .item-title{font-size:14px;font-weight:700;margin-bottom:4px;display:flex;align-items:center;gap:8px}
  .badge{display:inline-block;padding:2px 8px;border-radius:4px;font-size:10px;font-weight:800;text-transform:uppercase}
  .impact{color:#555;font-size:12px;margin:4px 0 8px}
  .action-box{background:#f0fdf4;border:1px solid #bbf7d0;padding:8px 12px;border-radius:6px;font-size:12px;color:#166534}
  .footer{margin-top:48px;padding-top:16px;border-top:1px solid #e5e7eb;color:#888;font-size:11px;display:flex;justify-content:space-between}
  @media print{body{padding:24px}@page{margin:1.5cm}}
</style></head><body>
<div class="header">
  <div>
    <div style="font-size:10px;text-transform:uppercase;letter-spacing:.1em;color:#888;margin-bottom:6px">${agency}</div>
    <h1>Audit Fiche Google Business</h1>
    <div style="font-size:18px;font-weight:800;margin-top:6px">${lead.name}</div>
    <div class="sub" style="margin-top:4px">📍 ${lead.address}</div>
    ${lead.rating != null ? `<div class="sub" style="margin-top:2px">⭐ ${lead.rating}/5 · ${lead.reviewCount} avis · ${lead.photoCount} photo${lead.photoCount !== 1 ? 's' : ''}</div>` : ''}
  </div>
  <div style="text-align:right;flex-shrink:0;margin-left:24px">
    <div class="score-num">${score}/100</div>
    <div style="font-size:11px;color:#888;margin-top:4px">Score de présence Google</div>
  </div>
</div>
${items.length === 0 ? '<p style="color:#16a34a;font-weight:700">✅ Fiche Google bien complétée — aucune amélioration nécessaire.</p>' : `
<div class="section-title">${items.length} point${items.length > 1 ? 's' : ''} à améliorer</div>
${items.map(item => {
  const [bg, fg] = priorityColor[item.priority] || ['#f3f4f6','#374151'];
  return `<div class="item" style="border-color:${fg}">
  <div class="item-title">
    <span>${item.icon}</span>
    <span>${item.title}</span>
    <span class="badge" style="background:${bg};color:${fg}">${item.priority}</span>
  </div>
  <div class="impact">${item.impact}</div>
  <div class="action-box">✏️ <strong>Action :</strong> ${item.action}</div>
</div>`;
}).join('')}`}
<div class="footer">
  <span>Rapport généré par <strong>${agency}</strong>${prefs.agencyPhone ? ' · ' + prefs.agencyPhone : ''}${prefs.agencyWebsite ? ' · ' + prefs.agencyWebsite : ''}</span>
  <span>${new Date().toLocaleDateString('fr-CA', { year:'numeric', month:'long', day:'numeric' })}</span>
</div>
</body></html>`;
    const win = window.open('', '_blank');
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => win.print(), 400);
  }

  function exportProposalPDF(lead, p) {
    const agency   = prefs.agencyName    || 'Ucreative Inc.';
    const tagline  = prefs.agencyTagline || 'Agence web & marketing digital';
    const phone    = prefs.agencyPhone   || '';
    const website  = prefs.agencyWebsite || '';
    const urgencyColor = { critique:['#fee2e2','#dc2626'], élevée:['#fef3c7','#d97706'], moyenne:['#dbeafe','#2563eb'] };
    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8">
<title>Devis — ${lead.name}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:-apple-system,Arial,sans-serif;max-width:800px;margin:0 auto;padding:48px 40px;color:#111;line-height:1.55;font-size:14px}
  .header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:32px;padding-bottom:24px;border-bottom:3px solid #C8FF00}
  .agency{font-size:11px;text-transform:uppercase;letter-spacing:.12em;color:#888;margin-bottom:6px}
  h1{font-size:22px;font-weight:900;margin-bottom:2px}
  .sub{color:#555;font-size:12px}
  .accroche{background:#f9fafb;border-left:4px solid #C8FF00;padding:16px 20px;border-radius:0 10px 10px 0;margin-bottom:28px;font-size:16px;font-weight:700;color:#111;line-height:1.4}
  .resume{color:#444;line-height:1.7;margin-bottom:28px}
  .section{margin-bottom:28px}
  .section-title{font-size:11px;font-weight:800;color:#888;text-transform:uppercase;letter-spacing:.1em;margin-bottom:12px;padding-bottom:8px;border-bottom:1px solid #e5e7eb}
  .problem{border-left:4px solid #e5e7eb;padding:10px 14px;margin:8px 0;border-radius:0 6px 6px 0}
  .problem-title{font-weight:700;font-size:13px;margin-bottom:3px;display:flex;align-items:center;gap:8px}
  .badge{display:inline-block;padding:2px 7px;border-radius:4px;font-size:10px;font-weight:800;text-transform:uppercase}
  .problem-desc{color:#555;font-size:12px;line-height:1.5}
  .service-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px}
  .service{background:#f9fafb;border:1px solid #e5e7eb;border-radius:8px;padding:14px}
  .service-name{font-weight:800;font-size:13px;margin-bottom:4px}
  .service-desc{color:#555;font-size:12px;margin-bottom:8px;line-height:1.4}
  .service-meta{display:flex;justify-content:space-between;align-items:center;gap:8px}
  .service-prix{font-weight:900;font-size:13px;color:#111}
  .service-delai{font-size:11px;color:#888;background:#e5e7eb;padding:2px 8px;border-radius:4px}
  .invest-box{background:#f0fdf4;border:1px solid #bbf7d0;border-radius:10px;padding:18px 20px;margin-bottom:20px}
  .invest-num{font-size:24px;font-weight:900;color:#16a34a}
  .roi{color:#166534;font-size:13px;margin-top:6px;line-height:1.5}
  .cta{background:#111;color:#C8FF00;border-radius:10px;padding:18px 20px;margin-bottom:20px}
  .cta-label{font-size:11px;text-transform:uppercase;letter-spacing:.1em;color:#666;margin-bottom:6px}
  .cta-text{font-size:16px;font-weight:800;margin-bottom:6px}
  .pourquoi{background:#fafafa;border:1px solid #e5e7eb;border-radius:8px;padding:14px 16px;margin-bottom:20px;color:#444;font-size:13px;line-height:1.6}
  .footer{margin-top:40px;padding-top:14px;border-top:1px solid #e5e7eb;color:#888;font-size:11px;display:flex;justify-content:space-between}
  .validity{display:inline-block;background:#fef9c3;border:1px solid #fde68a;color:#92400e;font-size:11px;font-weight:700;padding:3px 10px;border-radius:4px}
  @media print{body{padding:24px}@page{margin:1.5cm}}
</style></head><body>
<div class="header">
  <div>
    <div class="agency">${agency} — ${tagline}</div>
    <h1>Proposition commerciale</h1>
    <div class="sub">Préparée pour <strong>${lead.name}</strong> · ${lead.address}</div>
  </div>
  <div style="text-align:right;flex-shrink:0;margin-left:24px">
    <div style="font-size:11px;color:#888;margin-bottom:4px">Score actuel</div>
    <div style="font-size:36px;font-weight:900;color:#dc2626;line-height:1">${lead.score}/100</div>
    <div class="validity" style="margin-top:6px">Valide ${p.validite || '30 jours'}</div>
  </div>
</div>

<div class="accroche">${p.accroche || ''}</div>
<div class="resume">${p.resume || ''}</div>

${p.problemes?.length ? `<div class="section">
<div class="section-title">${p.problemes.length} problème${p.problemes.length > 1 ? 's' : ''} détecté${p.problemes.length > 1 ? 's' : ''}</div>
${p.problemes.map(pb => {
  const [bg, fg] = urgencyColor[pb.urgence] || ['#f3f4f6','#374151'];
  return `<div class="problem" style="border-color:${fg}">
  <div class="problem-title">${pb.titre} <span class="badge" style="background:${bg};color:${fg}">${pb.urgence}</span></div>
  <div class="problem-desc">${pb.desc}</div>
</div>`;
}).join('')}</div>` : ''}

${p.services?.length ? `<div class="section">
<div class="section-title">Services recommandés</div>
<div class="service-grid">
${p.services.map(sv => `<div class="service">
  <div class="service-name">${sv.nom}</div>
  <div class="service-desc">${sv.desc}</div>
  <div class="service-meta">
    <div class="service-prix">${sv.prix}</div>
    <div class="service-delai">⏱ ${sv.delai}</div>
  </div>
</div>`).join('')}
</div></div>` : ''}

${p.investissement ? `<div class="invest-box">
  <div style="font-size:11px;text-transform:uppercase;letter-spacing:.1em;color:#166534;margin-bottom:4px">Investissement total estimé</div>
  <div class="invest-num">${p.investissement}</div>
  ${p.roi ? `<div class="roi">📈 ${p.roi}</div>` : ''}
</div>` : ''}

${p.pourquoi_nous ? `<div class="section">
<div class="section-title">Pourquoi ${agency} ?</div>
<div class="pourquoi">${p.pourquoi_nous}</div>
</div>` : ''}

${p.prochaine_etape ? `<div class="cta">
  <div class="cta-label">Prochaine étape</div>
  <div class="cta-text">${p.prochaine_etape}</div>
  ${phone ? `<div style="color:#888;font-size:12px;margin-top:4px">📞 ${phone}${website ? '  ·  🌐 ' + website : ''}</div>` : ''}
</div>` : ''}

<div class="footer">
  <span>Proposition préparée par <strong>${agency}</strong>${phone ? ' · ' + phone : ''}${website ? ' · ' + website : ''}</span>
  <span>${new Date().toLocaleDateString('fr-CA', { year:'numeric', month:'long', day:'numeric' })}</span>
</div>
</body></html>`;
    const win = window.open('', '_blank');
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => win.print(), 400);
  }

  const inp = {
    background:'#0a0a0d', border:'1px solid rgba(255,255,255,0.08)',
    borderRadius:9, padding:'11px 14px', color:'#EAEAEA',
    fontSize:'0.88rem', outline:'none', width:'100%', boxSizing:'border-box',
  };

  return (
    <div style={{ padding:32, maxWidth:1300 }}>

      {/* ── HEADER ── */}
      <div style={{ marginBottom:24, display:'flex', alignItems:'flex-end', justifyContent:'space-between', flexWrap:'wrap', gap:16 }}>
        <div>
          <div style={{ fontSize:'0.65rem', color:'#333', fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:6 }}>Ucreative</div>
          <h1 style={{ fontSize:'2.1rem', fontWeight:900, color:'#EAEAEA', letterSpacing:'-0.04em', margin:0 }}>
            {viewTab === 'finder' ? 'Lead Finder' : 'Mon Pipeline'}
          </h1>
          <p style={{ color:'#3a3a3a', fontSize:'0.85rem', margin:'6px 0 0' }}>
            {viewTab === 'finder'
              ? 'Trouvez vos prochains clients via Google Business — chaque entreprise est scorée sur 100 selon sa présence en ligne'
              : 'Tous vos leads sauvegardés — suivez leur avancement, ajoutez des notes et gérez vos relances'}
          </p>
        </div>
        <div style={{ display:'flex', gap:6, background:'#080808', borderRadius:10, padding:4 }}>
          <button onClick={() => setViewTab('finder')}
            style={{ padding:'8px 20px', borderRadius:7, border:'none', cursor:'pointer', fontWeight:700, fontSize:'0.82rem', transition:'all 0.15s',
              background: viewTab === 'finder' ? '#C8FF00' : 'transparent',
              color:      viewTab === 'finder' ? '#000' : '#444' }}>
            🔍 Lead Finder
          </button>
          <button onClick={() => { setViewTab('pipeline'); loadPipeline(); }}
            style={{ padding:'8px 20px', borderRadius:7, border:'none', cursor:'pointer', fontWeight:700, fontSize:'0.82rem', transition:'all 0.15s',
              background: viewTab === 'pipeline' ? '#C8FF00' : 'transparent',
              color:      viewTab === 'pipeline' ? '#000' : '#444' }}>
            📋 Mon Pipeline {savedLeads.length > 0 && viewTab === 'pipeline' ? `(${savedLeads.length})` : ''}
          </button>
        </div>
      </div>

      {/* ══════════════════════════════════════
          VUE PIPELINE
      ══════════════════════════════════════ */}
      {viewTab === 'pipeline' && (
        <div>
          {pipelineLoading ? (
            <div style={{ textAlign:'center', padding:'60px 20px', color:'#444' }}>Chargement du pipeline…</div>
          ) : savedLeads.length === 0 ? (
            <div style={{ textAlign:'center', padding:'80px 20px' }}>
              <div style={{ fontSize:48, marginBottom:16 }}>📋</div>
              <div style={{ fontSize:'1rem', color:'#444', fontWeight:700, marginBottom:8 }}>Aucun lead sauvegardé</div>
              <div style={{ fontSize:'0.82rem', color:'#333' }}>Utilisez le Lead Finder et cliquez "Ajouter au CRM" sur chaque prospect.</div>
            </div>
          ) : (
            <>
              {/* ── Filtres statut ── */}
              <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' }}>
                {[{ value:'all', label:'Tous', color:'#C8FF00' }, ...STATUS_LIST].map(st => {
                  const count = st.value === 'all'
                    ? savedLeads.length
                    : savedLeads.filter(l => (l.pipelineStatus || 'à_contacter') === st.value).length;
                  const active = pipelineFilter === st.value;
                  return (
                    <button key={st.value} onClick={() => setPipelineFilter(st.value)}
                      style={{ padding:'6px 16px', borderRadius:20, border:`1px solid ${active ? (st.color || '#C8FF00') : 'rgba(255,255,255,0.08)'}`,
                        background: active ? `${(st.color || '#C8FF00')}18` : 'transparent',
                        color: active ? (st.color || '#C8FF00') : '#444',
                        cursor:'pointer', fontSize:'0.78rem', fontWeight: active ? 700 : 400, transition:'all 0.12s' }}>
                      {st.label} <span style={{ opacity:0.6, fontSize:'0.72rem' }}>({count})</span>
                    </button>
                  );
                })}
                <button onClick={loadPipeline} style={{ marginLeft:'auto', padding:'6px 14px', borderRadius:20, border:'1px solid rgba(255,255,255,0.08)', background:'transparent', color:'#444', cursor:'pointer', fontSize:'0.75rem' }}>
                  ↺ Actualiser
                </button>
              </div>

              {/* ── Compteurs rapides ── */}
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(110px,1fr))', gap:10, marginBottom:24 }}>
                {STATUS_LIST.map(st => {
                  const count = savedLeads.filter(l => (l.pipelineStatus || 'à_contacter') === st.value).length;
                  return (
                    <div key={st.value} style={{ background:'#0d0d10', border:'1px solid rgba(255,255,255,0.06)', borderRadius:12, padding:'14px 16px', textAlign:'center' }}>
                      <div style={{ fontSize:'1.6rem', fontWeight:900, color: st.color || '#888', lineHeight:1 }}>{count}</div>
                      <div style={{ fontSize:'0.68rem', color:'#444', marginTop:4, fontWeight:600 }}>{st.label}</div>
                    </div>
                  );
                })}
              </div>

              {/* ── Liste leads ── */}
              <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
                {savedLeads
                  .filter(l => pipelineFilter === 'all' || (l.pipelineStatus || 'à_contacter') === pipelineFilter)
                  .map(lead => {
                    const st = STATUS_LIST.find(s => s.value === (lead.pipelineStatus || 'à_contacter')) || STATUS_LIST[0];
                    const isEditingNote = editNoteId === lead.id;
                    const note = lead.notes || notesSaved[lead.id] || '';

                    return (
                      <div key={lead.id} style={{ background:'#0d0d10', border:'1px solid rgba(255,255,255,0.07)', borderRadius:14, padding:20 }}>
                        <div style={{ display:'flex', gap:16, alignItems:'flex-start', flexWrap:'wrap' }}>

                          {/* Score */}
                          <ScoreRing score={lead.score ?? 50} />

                          {/* Infos principales */}
                          <div style={{ flex:1, minWidth:200 }}>
                            <div style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap', marginBottom:4 }}>
                              <span style={{ fontWeight:800, color:'#EAEAEA', fontSize:'0.95rem' }}>{lead.name}</span>
                              <span style={{ fontSize:'0.65rem', padding:'2px 8px', borderRadius:10, background:`${st.color}18`, border:`1px solid ${st.color}44`, color:st.color, fontWeight:700 }}>{st.label}</span>
                              {lead.auditSentTo && <span style={{ fontSize:'0.65rem', color:'#4ade80', fontWeight:700 }}>📧 Audit envoyé</span>}
                              {lead.pitch      && <span style={{ fontSize:'0.65rem', color:'#63b3ed', fontWeight:700 }}>✍️ Pitch généré</span>}
                            </div>
                            <div style={{ fontSize:'0.78rem', color:'#444', marginBottom:2 }}>📍 {lead.address}</div>
                            {lead.phone   && <div style={{ fontSize:'0.78rem', color:'#444', marginBottom:2 }}>📞 {lead.phone}</div>}
                            {lead.website && <a href={lead.website} target="_blank" rel="noreferrer" style={{ fontSize:'0.75rem', color:'#C8FF00', textDecoration:'none' }}>🌐 {lead.website}</a>}
                            {lead.rating  && <div style={{ fontSize:'0.75rem', color:'#888', marginTop:2 }}>⭐ {lead.rating}/5 · {lead.reviewCount} avis · {lead.photoCount} photos</div>}
                            {lead.updatedAt && <div style={{ fontSize:'0.68rem', color:'#2a2a2a', marginTop:4 }}>Mis à jour : {new Date(lead.updatedAt).toLocaleDateString('fr-CA')}</div>}
                          </div>

                          {/* Statut + Actions */}
                          <div style={{ display:'flex', flexDirection:'column', gap:8, alignItems:'flex-end', flexShrink:0 }}>
                            <select value={lead.pipelineStatus || 'à_contacter'}
                              onChange={e => {
                                const newStatus = e.target.value;
                                setSavedLeads(prev => prev.map(l => l.id === lead.id ? { ...l, pipelineStatus: newStatus } : l));
                                ax.post('/api/leads', { placeId: lead.id, pipelineStatus: newStatus }).catch(()=>{});
                              }}
                              style={{ background:'#111', border:'1px solid rgba(255,255,255,0.1)', color:'#EAEAEA', borderRadius:8, padding:'6px 10px', fontSize:'0.75rem', cursor:'pointer', outline:'none' }}>
                              {STATUS_LIST.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                            </select>
                            {lead.mapsUrl && (
                              <a href={lead.mapsUrl} target="_blank" rel="noreferrer"
                                style={{ fontSize:'0.72rem', color:'#888', textDecoration:'none', border:'1px solid rgba(255,255,255,0.08)', borderRadius:6, padding:'4px 10px' }}>
                                📍 Google Maps
                              </a>
                            )}
                            <button onClick={() => { if (window.confirm('Supprimer ce lead du pipeline ?')) deletePipelineLead(lead.id); }}
                              title="Supprimer du pipeline"
                              style={{ background:'transparent', border:'1px solid rgba(255,60,60,0.3)', color:'#ff4444', borderRadius:6, padding:'4px 9px', fontSize:'0.82rem', cursor:'pointer', lineHeight:1, marginTop:2 }}>
                              🗑
                            </button>
                          </div>
                        </div>

                        {/* ── Notes ── */}
                        <div style={{ marginTop:14, borderTop:'1px solid rgba(255,255,255,0.05)', paddingTop:14 }}>
                          {isEditingNote ? (
                            <div style={{ display:'flex', gap:8, alignItems:'flex-end' }}>
                              <textarea value={noteDraft} onChange={e => setNoteDraft(e.target.value)}
                                rows={3} placeholder="Ajoutez vos notes ici…"
                                style={{ flex:1, background:'#111', border:'1px solid rgba(200,255,0,0.25)', borderRadius:8, padding:'10px 12px', color:'#EAEAEA', fontSize:'0.82rem', resize:'vertical', fontFamily:'inherit', outline:'none' }} />
                              <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                                <button onClick={() => saveNote(lead.id)}
                                  style={{ background:'#C8FF00', color:'#000', border:'none', borderRadius:7, padding:'7px 14px', fontSize:'0.75rem', fontWeight:800, cursor:'pointer' }}>
                                  Sauver
                                </button>
                                <button onClick={() => setEditNoteId(null)}
                                  style={{ background:'transparent', color:'#444', border:'1px solid rgba(255,255,255,0.08)', borderRadius:7, padding:'7px 14px', fontSize:'0.75rem', cursor:'pointer' }}>
                                  Annuler
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                              <div style={{ flex:1, fontSize:'0.8rem', color: note ? '#888' : '#2a2a2a', fontStyle: note ? 'normal' : 'italic', lineHeight:1.6, whiteSpace:'pre-wrap' }}>
                                {note || 'Aucune note — cliquez pour en ajouter'}
                              </div>
                              <button onClick={() => { setEditNoteId(lead.id); setNoteDraft(note); }}
                                style={{ flexShrink:0, background:'transparent', border:'1px solid rgba(255,255,255,0.08)', color:'#444', borderRadius:6, padding:'4px 10px', fontSize:'0.72rem', cursor:'pointer' }}>
                                ✏️ {note ? 'Modifier' : 'Note'}
                              </button>
                            </div>
                          )}
                        </div>

                      </div>
                    );
                  })}
              </div>

              {/* Export CSV pipeline */}
              <div style={{ marginTop:20, textAlign:'right' }}>
                <button onClick={() => {
                  const header = ['Nom','Adresse','Téléphone','Site','Score','Statut','Notes','Audit envoyé'];
                  const rows = savedLeads.map(l => [
                    l.name, l.address, l.phone||'', l.website||'', l.score,
                    l.pipelineStatus||'à_contacter', (l.notes||'').replace(/\n/g,' '),
                    l.auditSentTo||'',
                  ]);
                  const csv = [header,...rows].map(r => r.map(c=>`"${String(c).replace(/"/g,'""')}"`).join(',')).join('\n');
                  const a = document.createElement('a'); a.href = URL.createObjectURL(new Blob(['﻿'+csv],{type:'text/csv;charset=utf-8;'}));
                  a.download = `pipeline-${Date.now()}.csv`; a.click();
                }}
                  style={{ background:'transparent', border:'1px solid rgba(255,255,255,0.1)', color:'#666', borderRadius:8, padding:'8px 18px', fontSize:'0.78rem', cursor:'pointer', fontWeight:600 }}>
                  ⬇ Exporter CSV
                </button>
              </div>
            </>
          )}
        </div>
      )}

      {viewTab === 'finder' && (<>

      {/* ── PANNEAU RECHERCHE ── */}
      <div style={{ background:'#0d0d10', border:'1px solid rgba(255,255,255,0.07)', borderRadius:16, padding:26, marginBottom:22 }}>

        {/* Toggle mode */}
        <div style={{ display:'flex', gap:6, marginBottom:22, background:'#080808', borderRadius:10, padding:4, width:'fit-content' }}>
          <button onClick={() => { setMode('category'); setResults([]); setError(null); }}
            style={{ padding:'7px 18px', borderRadius:7, border:'none', cursor:'pointer', fontWeight:700, fontSize:'0.8rem', transition:'all 0.15s',
              background: mode === 'category' ? '#C8FF00' : 'transparent',
              color:      mode === 'category' ? '#000' : '#444' }}>
            🔍 Par catégorie
          </button>
          <button onClick={() => { setMode('general'); setResults([]); setError(null); }}
            style={{ padding:'7px 18px', borderRadius:7, border:'none', cursor:'pointer', fontWeight:700, fontSize:'0.8rem', transition:'all 0.15s',
              background: mode === 'general' ? '#C8FF00' : 'transparent',
              color:      mode === 'general' ? '#000' : '#444' }}>
            🌍 Mode général
          </button>
        </div>

        {mode === 'category' ? (
          <>
            {/* Catégories rapides */}
            <div style={{ marginBottom:20 }}>
              <div style={{ fontSize:'0.65rem', color:'#333', fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:10 }}>Catégories rapides</div>
              <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                {CATEGORIES.map(cat => {
                  const active = query === cat.q;
                  return (
                    <button key={cat.q} onClick={() => setQuery(cat.q)}
                      style={{ background: active ? 'rgba(200,255,0,0.08)' : '#111',
                        border: `1px solid ${active ? 'rgba(200,255,0,0.35)' : 'rgba(255,255,255,0.06)'}`,
                        color: active ? '#C8FF00' : '#444',
                        padding:'5px 13px', borderRadius:20, cursor:'pointer',
                        fontSize:'0.78rem', fontWeight: active ? 700 : 400,
                        transition:'all 0.12s' }}>
                      {cat.label}
                    </button>
                  );
                })}
              </div>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:16 }}>
              <div>
                <div style={{ fontSize:'0.65rem', color:'#333', fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:6 }}>Type de commerce</div>
                <input style={inp} value={query} onChange={e => setQuery(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && search()}
                  placeholder="ex: restaurant, plombier, dentiste..." />
              </div>
              <div>
                <div style={{ fontSize:'0.65rem', color:'#333', fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:6 }}>Ville / Région</div>
                <input style={inp} value={location} onChange={e => setLocation(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && search()}
                  placeholder="ex: Montréal QC, Laval, Québec..." />
              </div>
            </div>
            <button onClick={search} disabled={loading || !query.trim()}
              style={{ width:'100%', padding:'14px', borderRadius:11, border:'none',
                cursor: loading || !query.trim() ? 'default' : 'pointer',
                background: loading || !query.trim() ? '#111' : '#C8FF00',
                color: loading || !query.trim() ? '#333' : '#000',
                fontWeight:900, fontSize:'0.95rem', letterSpacing:'0.02em', transition:'all 0.15s' }}>
              {loading ? '🔍  Analyse en cours...' : '🔍  Lancer la recherche'}
            </button>
          </>
        ) : (
          <>
            {/* Description mode général */}
            <div style={{ background:'rgba(200,255,0,0.04)', border:'1px solid rgba(200,255,0,0.12)', borderRadius:9, padding:'10px 14px', marginBottom:20, fontSize:'0.8rem', color:'#888', lineHeight:1.6 }}>
              🌍 <strong style={{color:'#C8FF00'}}>Mode général</strong> — Balaye toute une zone géographique et remonte <em>toutes</em> les fiches Google Business sans filtrer par catégorie. Idéal pour voir d'un coup d'œil les fiches mal faites d'une région.
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr', gap:14, marginBottom:16 }}>
              <div>
                <div style={{ fontSize:'0.65rem', color:'#333', fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:6 }}>Ville / Région</div>
                <input style={inp} value={location} onChange={e => setLocation(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && sweep()}
                  placeholder="ex: Montréal QC, Laval, Longueuil..." />
              </div>
              <div>
                <div style={{ fontSize:'0.65rem', color:'#333', fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:6 }}>Rayon de recherche</div>
                <select style={{ ...inp, cursor:'pointer' }} value={radius} onChange={e => setRadius(Number(e.target.value))}>
                  <option value={2000}>2 km — quartier</option>
                  <option value={5000}>5 km — secteur</option>
                  <option value={10000}>10 km — ville</option>
                  <option value={20000}>20 km — grande région</option>
                </select>
              </div>
            </div>

            {/* Filtre rapide sans site web */}
            <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16, flexWrap:'wrap' }}>
              <button onClick={() => setNoWebsite(!noWebsite)}
                style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 14px', borderRadius:8, border:`1px solid ${noWebsite ? 'rgba(248,113,113,0.4)' : 'rgba(255,255,255,0.08)'}`,
                  background: noWebsite ? 'rgba(248,113,113,0.08)' : 'transparent',
                  color: noWebsite ? '#f87171' : '#444', cursor:'pointer', fontSize:'0.8rem', fontWeight: noWebsite ? 700 : 400, transition:'all 0.15s' }}>
                <div style={{ width:14, height:14, borderRadius:3, border:`2px solid ${noWebsite ? '#f87171' : '#333'}`,
                  background: noWebsite ? '#f87171' : 'transparent', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  {noWebsite && <span style={{ color:'#000', fontSize:9, fontWeight:900, lineHeight:1 }}>✓</span>}
                </div>
                🌐 Sans site web uniquement
              </button>
              <span style={{ color:'#2a2a2a', fontSize:'0.75rem' }}>
                {noWebsite ? 'Affiche seulement les fiches sans site web' : 'Affiche toutes les fiches'}
              </span>
            </div>

            <button onClick={sweep} disabled={loading || !location.trim()}
              style={{ width:'100%', padding:'14px', borderRadius:11, border:'none',
                cursor: loading || !location.trim() ? 'default' : 'pointer',
                background: loading || !location.trim() ? '#111' : '#C8FF00',
                color: loading || !location.trim() ? '#333' : '#000',
                fontWeight:900, fontSize:'0.95rem', letterSpacing:'0.02em', transition:'all 0.15s' }}>
              {loading ? '🌍  Balayage en cours...' : `🌍  Balayer ${radius >= 10000 ? radius/1000 + ' km' : radius/1000 + ' km'} autour de ${location.split(',')[0] || 'la ville'}`}
            </button>

            {loading && (
              <div style={{ marginTop:12, color:'#444', fontSize:'0.75rem', textAlign:'center', lineHeight:1.7 }}>
                ⏳ Geocodage → Nearbysearch (jusqu'à 3 pages) → Enrichissement des fiches...<br/>
                <span style={{ color:'#2a2a2a' }}>Peut prendre 10–20 secondes selon le rayon</span>
              </div>
            )}
          </>
        )}
      </div>

      {/* ── ERREUR ── */}
      {error && (
        <div style={{ background:'rgba(248,113,113,0.06)', border:'1px solid rgba(248,113,113,0.2)', borderRadius:12, padding:'16px 20px', marginBottom:22 }}>
          <div style={{ color:'#f87171', fontWeight:700, fontSize:'0.88rem', marginBottom:4 }}>
            {error.setup ? '🔑 Clé API manquante' : '⚠️ Erreur'}
          </div>
          <div style={{ color:'#f87171cc', fontSize:'0.82rem' }}>{error.error || String(error)}</div>
          {error.setup && (
            <div style={{ marginTop:12, background:'#0a0005', borderRadius:8, padding:'12px 14px', fontSize:'0.78rem', color:'#f87171aa', lineHeight:2 }}>
              1. Créez un projet sur <strong style={{color:'#f87171'}}>console.cloud.google.com</strong><br/>
              2. Activez <strong style={{color:'#f87171'}}>Places API</strong><br/>
              3. Créez une clé API et ajoutez dans votre fichier <code style={{background:'#1a0000',padding:'1px 5px',borderRadius:3}}>.env</code> :<br/>
              <code style={{background:'#1a0000',padding:'4px 8px',borderRadius:4,display:'inline-block',marginTop:4}}>GOOGLE_PLACES_API_KEY=AIza...</code><br/>
              4. Redémarrez le serveur
            </div>
          )}
        </div>
      )}

      {/* ── BARRE STATS ── */}
      {results.length > 0 && (
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12,
          background:'#0d0d10', border:'1px solid rgba(255,255,255,0.06)', borderRadius:11,
          padding:'12px 18px', marginBottom:22 }}>
          <div style={{ display:'flex', gap:20, alignItems:'center', flexWrap:'wrap' }}>
            <span style={{ color:'#EAEAEA', fontWeight:800, fontSize:'0.92rem' }}>{results.length} entreprises</span>
            <span style={{ color:'#f87171', fontWeight:700, fontSize:'0.82rem' }}>🔴 {hot} chauds</span>
            <span style={{ color:'#fbbf24', fontWeight:700, fontSize:'0.82rem' }}>🟡 {warm} tièdes</span>
            <span style={{ color:'#4ade80', fontWeight:700, fontSize:'0.82rem' }}>🟢 {results.length - hot - warm} établis</span>
          </div>
          <div style={{ display:'flex', gap:7, alignItems:'center', flexWrap:'wrap' }}>
            <span style={{ color:'#333', fontSize:'0.75rem' }}>Afficher ≤</span>
            {[100, 60, 30].map(v => (
              <button key={v} onClick={() => setMaxScore(v)}
                style={{ background: maxScore === v ? 'rgba(200,255,0,0.08)' : 'transparent',
                  border:`1px solid ${maxScore === v ? 'rgba(200,255,0,0.3)' : 'rgba(255,255,255,0.07)'}`,
                  color: maxScore === v ? '#C8FF00' : '#444',
                  padding:'4px 11px', borderRadius:6, cursor:'pointer', fontSize:'0.75rem', fontWeight:700 }}>
                {v === 100 ? 'Tous' : `≤ ${v}`}
              </button>
            ))}
            <button onClick={exportCSV}
              style={{ background:'rgba(99,179,237,0.07)', border:'1px solid rgba(99,179,237,0.2)',
                color:'#63b3ed', padding:'5px 14px', borderRadius:7,
                cursor:'pointer', fontSize:'0.78rem', fontWeight:600, marginLeft:4 }}>
              ⬇ Exporter CSV
            </button>
          </div>
        </div>
      )}

      {/* ── GRILLE RÉSULTATS ── */}
      {filtered.length > 0 && (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(390px, 1fr))', gap:14 }}>
          {filtered.map(lead => {
            const sc    = scoreStyle(lead.score);
            const added = crmAdded.has(lead.id);
            const label = typeLabel(lead.types);
            return (
              <div key={lead.id} style={{ background:'#0d0d10', border:`1px solid ${sc.bd}33`,
                borderRadius:14, overflow:'hidden', display:'flex', flexDirection:'column',
                transition:'border-color 0.15s' }}>

                {/* Barre couleur haut */}
                <div style={{ height:3, background:`linear-gradient(90deg, ${sc.c}, transparent)` }} />

                {/* Screenshot miniature */}
                {lead.website && (() => {
                  const url = lead.website.startsWith('http') ? lead.website : 'https://' + lead.website;
                  const src = `https://s.wordpress.com/mshots/v1/${encodeURIComponent(url)}?w=600&h=180`;
                  return (
                    <div style={{ width:'100%', height:90, overflow:'hidden', background:'#0a0a0a', position:'relative', flexShrink:0 }}>
                      <img
                        src={src}
                        alt=""
                        loading="lazy"
                        style={{ width:'100%', height:'100%', objectFit:'cover', objectPosition:'top', display:'block', opacity:0.85 }}
                        onError={e => { e.target.parentElement.style.display = 'none'; }}
                      />
                      <div style={{ position:'absolute', bottom:0, left:0, right:0, height:36, background:'linear-gradient(transparent, #0d0d10)' }} />
                    </div>
                  );
                })()}

                <div style={{ padding:'18px 18px 14px' }}>

                  {/* Score + infos principales */}
                  <div style={{ display:'flex', gap:14, alignItems:'flex-start', marginBottom:14 }}>
                    <ScoreRing score={lead.score} />
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:4 }}>
                        <span style={{ background:sc.bg, border:`1px solid ${sc.bd}`, color:sc.c,
                          fontSize:'0.6rem', fontWeight:800, padding:'2px 7px', borderRadius:4, letterSpacing:'0.07em' }}>
                          {sc.label}
                        </span>
                        {label && <span style={{ color:'#444', fontSize:'0.72rem' }}>{label}</span>}
                      </div>
                      <div style={{ color:'#EAEAEA', fontWeight:700, fontSize:'0.95rem', lineHeight:1.3, wordBreak:'break-word' }}>
                        {lead.name}
                      </div>
                      <div style={{ color:'#3a3a3a', fontSize:'0.74rem', marginTop:3, lineHeight:1.4 }}>
                        📍 {lead.address}
                      </div>
                    </div>
                  </div>

                  {/* Détails */}
                  <div style={{ display:'flex', flexDirection:'column', gap:6, marginBottom:14, paddingLeft:2 }}>
                    <div style={{ display:'flex', gap:16, flexWrap:'wrap', alignItems:'center' }}>
                      {lead.phone
                        ? <span style={{ color:'#555', fontSize:'0.8rem' }}>📞 {lead.phone}</span>
                        : <span style={{ color:'#2a2a2a', fontSize:'0.8rem' }}>📞 Pas de téléphone</span>
                      }
                      {lead.website
                        ? (
                          <a href={lead.website} target="_blank" rel="noreferrer"
                            style={{ color: lead.website.startsWith('https') ? '#4ade80' : '#fbbf24',
                              fontSize:'0.78rem', textDecoration:'none',
                              maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', display:'block' }}>
                            {lead.website.startsWith('https') ? '🔒' : '⚠️'} {lead.website.replace(/^https?:\/\/(www\.)?/, '')}
                          </a>
                        ) : (
                          <span style={{ color:'#f87171', fontSize:'0.8rem', fontWeight:700 }}>🌐 Aucun site web</span>
                        )
                      }
                    </div>
                    {/* Tech détectée */}
                    {techLoading.has(lead.id) && (
                      <span style={{ color:'#333', fontSize:'0.72rem' }}>🔍 Analyse en cours...</span>
                    )}
                    {!techLoading.has(lead.id) && techs[lead.id] !== undefined && (() => {
                      const t = techs[lead.id];
                      if (!t) return <span style={{ color:'#2a2a2a', fontSize:'0.72rem' }}>🔍 Site non accessible</span>;

                      const isDiy = t.platform?.type === 'diy';
                      const platformName = t.platform?.name || (t.generator?.split(' ')[0]) || null;
                      const platformIcon = t.platform?.icon || '⚙️';

                      return (
                        <div style={{ display:'flex', flexWrap:'wrap', gap:5, alignItems:'center' }}>

                          {/* Plateforme / CMS */}
                          {platformName ? (
                            <span style={{
                              background: isDiy ? 'rgba(251,191,36,0.1)' : 'rgba(255,255,255,0.04)',
                              border:`1px solid ${isDiy ? 'rgba(251,191,36,0.3)' : 'rgba(255,255,255,0.1)'}`,
                              color: isDiy ? '#fbbf24' : '#888',
                              fontSize:'0.7rem', padding:'2px 9px', borderRadius:5, fontWeight: isDiy ? 700 : 500 }}>
                              {platformIcon} {platformName}
                            </span>
                          ) : (
                            <span style={{ color:'#2a2a2a', fontSize:'0.72rem' }}>🔍 Plateforme inconnue</span>
                          )}

                          {/* Builder (ex: Elementor sur WP) */}
                          {t.builder && (
                            <span style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.07)',
                              color:'#555', fontSize:'0.68rem', padding:'2px 8px', borderRadius:5 }}>
                              + {t.builder}
                            </span>
                          )}

                          {/* Agence web trouvée */}
                          {t.agency && (
                            <span style={{ background:'rgba(248,113,113,0.08)', border:'1px solid rgba(248,113,113,0.2)',
                              color:'#f87171', fontSize:'0.68rem', padding:'2px 9px', borderRadius:5, fontWeight:600 }}>
                              🏢 {t.agency}
                            </span>
                          )}

                          {/* Serveur si rien d'autre */}
                          {!platformName && !t.agency && t.server && (
                            <span style={{ color:'#2a2a2a', fontSize:'0.68rem' }}>⚙️ {t.server}</span>
                          )}

                          {isDiy && <span style={{ color:'#fbbf24', fontSize:'0.63rem', fontWeight:700 }}>← opportunité!</span>}

                          {/* PageSpeed score */}
                          {techs[lead.id]?.pagespeed && (() => {
                            const ps = techs[lead.id].pagespeed;
                            const c  = ps.score >= 70 ? '#4ade80' : ps.score >= 40 ? '#fbbf24' : '#f87171';
                            return (
                              <span title={`Vitesse mobile : ${ps.fcp ? 'FCP ' + ps.fcp : ''}${ps.lcp ? ' · LCP ' + ps.lcp : ''}`}
                                style={{ background:`${c}12`, border:`1px solid ${c}30`, color:c, fontSize:'0.65rem', fontWeight:800, padding:'2px 8px', borderRadius:4, cursor:'default' }}>
                                ⚡ {ps.score}/100
                              </span>
                            );
                          })()}

                          {/* SEO score */}
                          {techs[lead.id]?.seo && (() => {
                            const s = techs[lead.id].seo;
                            const pts = [s.titleOk, s.metaOk, s.h1Ok, s.altOk, s.hasAnalytics].filter(Boolean).length;
                            const c   = pts >= 4 ? '#4ade80' : pts >= 2 ? '#fbbf24' : '#f87171';
                            return (
                              <span title={`SEO : Titre ${s.titleOk?'✓':'✗'} · Meta ${s.metaOk?'✓':'✗'} · H1 ${s.h1Ok?'✓':'✗'} · Analytics ${s.hasAnalytics?'✓':'✗'}`}
                                style={{ background:`${c}12`, border:`1px solid ${c}30`, color:c, fontSize:'0.65rem', fontWeight:800, padding:'2px 8px', borderRadius:4, cursor:'default' }}>
                                🔍 SEO {pts}/5
                              </span>
                            );
                          })()}

                          {/* Loi 25 */}
                          {techs[lead.id]?.legal && !techs[lead.id].legal.hasPrivacy && (
                            <span title="Aucune politique de confidentialité détectée — non conforme Loi 25"
                              style={{ background:'rgba(248,113,113,0.1)', border:'1px solid rgba(248,113,113,0.3)', color:'#f87171', fontSize:'0.65rem', fontWeight:800, padding:'2px 8px', borderRadius:4, cursor:'default' }}>
                              ⚖️ Loi 25
                            </span>
                          )}

                          {/* Cadenas de sécurité visibles directement */}
                          {techs[lead.id]?.failles?.length > 0 && (() => {
                            const f = techs[lead.id].failles;
                            const lvls = [
                              { key:'critical', color:'#f87171', icon:'🔴' },
                              { key:'high',     color:'#fb923c', icon:'🟠' },
                              { key:'medium',   color:'#fbbf24', icon:'🟡' },
                              { key:'low',      color:'#60a5fa', icon:'🔵' },
                            ];
                            return (
                              <div style={{ display:'flex', gap:4, alignItems:'center', flexWrap:'wrap' }}>
                                {lvls.map(l => {
                                  const n = f.filter(x => x.level === l.key).length;
                                  if (!n) return null;
                                  return (
                                    <span key={l.key} title={`${n} faille${n>1?'s':''} ${l.key}`}
                                      style={{ background:`${l.color}12`, border:`1px solid ${l.color}30`,
                                        color:l.color, fontSize:'0.65rem', fontWeight:800,
                                        padding:'2px 7px', borderRadius:4, cursor:'pointer' }}
                                      onClick={() => setShowSecurity(prev => { const s = new Set(prev); s.add(lead.id); return s; })}>
                                      🔐 {n} {l.key}
                                    </span>
                                  );
                                })}
                              </div>
                            );
                          })()}
                        </div>
                      );
                    })()}

                    <div style={{ display:'flex', gap:16, flexWrap:'wrap', alignItems:'center' }}>
                      {lead.rating != null && (
                        <span style={{ color:'#555', fontSize:'0.8rem' }}>
                          ⭐ <span style={{ color: lead.rating >= 4 ? '#4ade80' : lead.rating >= 3.5 ? '#fbbf24' : '#f87171', fontWeight:700 }}>
                            {lead.rating}
                          </span>
                          <span style={{ color:'#333' }}> ({lead.reviewCount} avis)</span>
                        </span>
                      )}
                      <span style={{ color:'#444', fontSize:'0.8rem' }}>
                        📸 {lead.photoCount} photo{lead.photoCount !== 1 ? 's' : ''}
                      </span>
                      {!lead.hasHours && (
                        <span style={{ color:'#2a2a2a', fontSize:'0.78rem' }}>🕐 Pas d'horaires</span>
                      )}
                    </div>
                  </div>

                  {/* Pills lacunes */}
                  {lead.reasons.length > 0 && (
                    <div style={{ display:'flex', flexWrap:'wrap', gap:5, marginBottom:10 }}>
                      {lead.reasons.map((r, i) => (
                        <span key={i} style={{ background:`${sc.c}10`, border:`1px solid ${sc.c}22`,
                          color:sc.c, fontSize:'0.67rem', padding:'2px 8px', borderRadius:10,
                          fontWeight:600, whiteSpace:'nowrap' }}>
                          {r.icon} {r.text}
                        </span>
                      ))}
                    </div>
                  )}

                  {/* Status suivi commercial */}
                  <div style={{ display:'flex', flexWrap:'wrap', gap:5 }}>
                    {STATUS_LIST.map(st => {
                      const active = leadStatuses[lead.id] === st.value;
                      return (
                        <button key={st.value} onClick={() => updateLeadStatus(lead, st.value)}
                          style={{ background: active ? `${st.color}18` : 'transparent',
                            border:`1px solid ${active ? st.color + '55' : 'rgba(255,255,255,0.06)'}`,
                            color: active ? st.color : '#2e2e2e',
                            padding:'3px 9px', borderRadius:5, cursor:'pointer',
                            fontSize:'0.67rem', fontWeight: active ? 700 : 400, transition:'all 0.12s' }}>
                          {st.label}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* ── PLAN D'AMÉLIORATION ── */}
                {showPlan.has(lead.id) && (() => {
                  const recos = lead.reasons
                    .map(r => RECO_MAP.find(m => r.text.includes(m.match)))
                    .filter(Boolean);
                  const gainTotal = recos.reduce((acc, r) => acc + r.gain, 0);
                  return (
                    <div style={{ margin:'0 18px 12px', background:'#080810', border:'1px solid rgba(200,255,0,0.12)', borderRadius:10, overflow:'hidden' }}>
                      <div style={{ padding:'10px 14px', borderBottom:'1px solid rgba(200,255,0,0.08)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                        <span style={{ color:'#C8FF00', fontSize:'0.72rem', fontWeight:800, letterSpacing:'0.08em', textTransform:'uppercase' }}>Plan pour atteindre 100/100</span>
                        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                          <span style={{ fontSize:'0.72rem', color:'#555' }}>{lead.score}/100</span>
                          <span style={{ color:'#333', fontSize:'0.72rem' }}>→</span>
                          <span style={{ fontSize:'0.78rem', color:'#C8FF00', fontWeight:800 }}>{Math.min(lead.score + gainTotal, 100)}/100</span>
                        </div>
                      </div>
                      {recos.length === 0 ? (
                        <div style={{ padding:'12px 14px', color:'#333', fontSize:'0.78rem' }}>Aucune amélioration identifiée.</div>
                      ) : (
                        <div style={{ display:'flex', flexDirection:'column' }}>
                          {recos.map((reco, i) => (
                            <div key={i} style={{ padding:'10px 14px', borderBottom: i < recos.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none',
                              display:'flex', alignItems:'flex-start', gap:10 }}>
                              <span style={{ fontSize:18, flexShrink:0 }}>{reco.icon}</span>
                              <div style={{ flex:1 }}>
                                <div style={{ color:'#EAEAEA', fontSize:'0.8rem', fontWeight:700, marginBottom:2 }}>{reco.action}</div>
                                <div style={{ color:'#555', fontSize:'0.72rem' }}>Service à proposer : <span style={{ color:'#888' }}>{reco.service}</span></div>
                              </div>
                              <span style={{ background:'rgba(200,255,0,0.08)', border:'1px solid rgba(200,255,0,0.2)',
                                color:'#C8FF00', fontSize:'0.65rem', fontWeight:800, padding:'2px 7px',
                                borderRadius:5, flexShrink:0, whiteSpace:'nowrap' }}>
                                +{reco.gain} pts
                              </span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })()}

                {/* Emails trouvés */}
                {emails[lead.id] !== undefined && (
                  <div style={{ margin:'0 18px 10px', padding:'10px 12px',
                    background:'rgba(99,179,237,0.05)', border:'1px solid rgba(99,179,237,0.15)',
                    borderRadius:8 }}>
                    {emails[lead.id].length === 0 ? (
                      <span style={{ color:'#333', fontSize:'0.75rem' }}>Aucun email trouvé sur le site</span>
                    ) : emails[lead.id].map(email => (
                      <div key={email} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:8 }}>
                        <span style={{ color:'#63b3ed', fontSize:'0.78rem', fontWeight:600 }}>📧 {email}</span>
                        <button onClick={() => copyEmail(email)}
                          style={{ background:'transparent', border:'none', color: copied === 'email-' + email ? '#4ade80' : '#444',
                            cursor:'pointer', fontSize:'0.72rem', padding:'2px 6px', borderRadius:4, flexShrink:0 }}>
                          {copied === 'email-' + email ? '✓' : 'Copier'}
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                {/* Failles de sécurité */}
                {showSecurity.has(lead.id) && techs[lead.id]?.failles?.length > 0 && (() => {
                  const failles = techs[lead.id].failles;
                  const colors = { critical:'#f87171', high:'#fb923c', medium:'#fbbf24', low:'#60a5fa', info:'#888' };
                  const critCount  = failles.filter(f => f.level === 'critical').length;
                  const highCount  = failles.filter(f => f.level === 'high').length;
                  return (
                    <div style={{ margin:'0 18px 12px', background:'#0a0005', border:'1px solid rgba(248,113,113,0.2)', borderRadius:10, overflow:'hidden' }}>
                      <div style={{ padding:'10px 14px', borderBottom:'1px solid rgba(248,113,113,0.1)', display:'flex', alignItems:'center', gap:8 }}>
                        <span style={{ color:'#f87171', fontSize:'0.72rem', fontWeight:800, letterSpacing:'0.08em', textTransform:'uppercase' }}>🔐 Rapport de sécurité</span>
                        <span style={{ marginLeft:'auto', display:'flex', gap:5 }}>
                          {critCount > 0 && <span style={{ background:'rgba(248,113,113,0.15)', border:'1px solid rgba(248,113,113,0.3)', color:'#f87171', fontSize:'0.65rem', fontWeight:800, padding:'1px 7px', borderRadius:4 }}>{critCount} critique{critCount > 1 ? 's' : ''}</span>}
                          {highCount > 0 && <span style={{ background:'rgba(251,146,60,0.12)', border:'1px solid rgba(251,146,60,0.3)', color:'#fb923c', fontSize:'0.65rem', fontWeight:800, padding:'1px 7px', borderRadius:4 }}>{highCount} élevé{highCount > 1 ? 's' : ''}</span>}
                        </span>
                      </div>
                      <div style={{ display:'flex', flexDirection:'column' }}>
                        {failles.map((f, i) => {
                          const c = colors[f.level] || '#888';
                          return (
                            <div key={i} style={{ padding:'14px', borderBottom: i < failles.length - 1 ? '1px solid rgba(255,255,255,0.03)' : 'none' }}>
                              {/* Titre faille */}
                              <div style={{ display:'flex', alignItems:'flex-start', gap:10, marginBottom:8 }}>
                                <span style={{ fontSize:16, flexShrink:0, marginTop:1 }}>{f.icon}</span>
                                <div style={{ flex:1 }}>
                                  <div style={{ color: c, fontSize:'0.8rem', fontWeight:800, marginBottom:2 }}>{f.text}</div>
                                  <div style={{ color:'#555', fontSize:'0.72rem', lineHeight:1.55 }}>{f.desc}</div>
                                </div>
                                <span style={{ background:`${c}12`, border:`1px solid ${c}30`, color:c, fontSize:'0.6rem', fontWeight:800, padding:'2px 6px', borderRadius:4, flexShrink:0, textTransform:'uppercase', marginTop:2 }}>{f.level}</span>
                              </div>
                              {/* Comment exploiter */}
                              {f.exploit && (
                                <div style={{ marginLeft:26, marginBottom:6, background:'rgba(248,113,113,0.05)', border:'1px solid rgba(248,113,113,0.1)', borderRadius:6, padding:'8px 10px' }}>
                                  <div style={{ color:'#f87171', fontSize:'0.63rem', fontWeight:800, letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:4 }}>⚔️ Comment un hacker exploite ça</div>
                                  <div style={{ color:'#666', fontSize:'0.71rem', lineHeight:1.6 }}>{f.exploit}</div>
                                </div>
                              )}
                              {/* Comment corriger */}
                              {f.fix && (
                                <div style={{ marginLeft:26, background:'rgba(74,222,128,0.04)', border:'1px solid rgba(74,222,128,0.12)', borderRadius:6, padding:'8px 10px' }}>
                                  <div style={{ color:'#4ade80', fontSize:'0.63rem', fontWeight:800, letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:4 }}>✅ Comment corriger</div>
                                  <div style={{ color:'#666', fontSize:'0.71rem', lineHeight:1.6 }}>{f.fix}</div>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                      <div style={{ padding:'10px 14px', background:'rgba(248,113,113,0.04)', borderTop:'1px solid rgba(248,113,113,0.08)' }}>
                        <div style={{ color:'#f87171aa', fontSize:'0.7rem', lineHeight:1.6 }}>
                          💡 <strong style={{color:'#f87171'}}>Argument de vente :</strong> Ces failles sont visibles publiquement — vos clients et leurs clients sont exposés dès aujourd'hui.
                        </div>
                      </div>
                    </div>
                  );
                })()}

                {/* Rapport SEO + Loi 25 */}
                {showSecurity.has(lead.id) && techs[lead.id]?.seo && (() => {
                  const s  = techs[lead.id].seo;
                  const lg = techs[lead.id].legal || {};
                  const ps = techs[lead.id].pagespeed;
                  const rows = [
                    { ok: s.titleOk,       label: 'Balise titre',          detail: s.title ? `"${s.title.slice(0,50)}"` : 'Absente' },
                    { ok: s.metaOk,        label: 'Meta description',      detail: s.metaDesc ? `"${s.metaDesc.slice(0,50)}…"` : 'Absente' },
                    { ok: s.h1Ok,          label: 'Balise H1',             detail: s.h1 ? `"${s.h1.slice(0,40)}"` : 'Absente' },
                    { ok: s.altOk,         label: 'Alt des images',        detail: s.imgTotal > 0 ? `${s.imgWithAlt}/${s.imgTotal} images avec alt` : 'Aucune image' },
                    { ok: s.hasAnalytics,  label: 'Google Analytics',      detail: s.hasAnalytics ? 'Installé' : 'Absent — trafic non mesuré' },
                    { ok: s.hasContactForm,label: 'Formulaire de contact', detail: s.hasContactForm ? 'Présent' : 'Absent — clients ne peuvent pas écrire' },
                    { ok: s.hasSocials,    label: 'Liens réseaux sociaux', detail: s.hasSocials ? 'Présents' : 'Absents — zéro présence sociale' },
                    { ok: lg.hasPrivacy,   label: 'Politique de confidentialité (Loi 25)', detail: lg.hasPrivacy ? 'Détectée' : '⚠️ Absente — non conforme au Québec' },
                    { ok: lg.hasCookies,   label: 'Gestion des cookies',   detail: lg.hasCookies ? 'Présente' : 'Absente' },
                    { ok: lg.hasTOS,       label: 'Conditions d\'utilisation', detail: lg.hasTOS ? 'Présentes' : 'Absentes' },
                  ];
                  return (
                    <div style={{ margin:'0 18px 12px', background:'#080a0f', border:'1px solid rgba(99,179,237,0.18)', borderRadius:10, overflow:'hidden' }}>
                      <div style={{ padding:'10px 14px', borderBottom:'1px solid rgba(99,179,237,0.1)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                        <span style={{ color:'#63b3ed', fontSize:'0.72rem', fontWeight:800, letterSpacing:'0.08em', textTransform:'uppercase' }}>🔍 Audit SEO & Conformité Loi 25</span>
                        {ps && (() => {
                          const c = ps.score >= 70 ? '#4ade80' : ps.score >= 40 ? '#fbbf24' : '#f87171';
                          return <span style={{ color:c, fontWeight:900, fontSize:'0.8rem' }}>⚡ PageSpeed mobile : {ps.score}/100{ps.fcp ? ` · FCP ${ps.fcp}` : ''}</span>;
                        })()}
                      </div>
                      <div style={{ display:'flex', flexDirection:'column' }}>
                        {rows.map((row, i) => (
                          <div key={i} style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 14px', borderBottom: i < rows.length - 1 ? '1px solid rgba(255,255,255,0.03)' : 'none' }}>
                            <span style={{ fontSize:14, flexShrink:0 }}>{row.ok ? '✅' : '❌'}</span>
                            <span style={{ color: row.ok ? '#555' : '#EAEAEA', fontSize:'0.78rem', fontWeight: row.ok ? 400 : 600, flex:1 }}>{row.label}</span>
                            <span style={{ color:'#444', fontSize:'0.7rem', textAlign:'right', maxWidth:200 }}>{row.detail}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })()}

                {/* Envoi courriel audit */}
                {showAuditInput.has(lead.id) && (
                  <div style={{ margin:'0 18px 12px', background:'#06080f', border:'1px solid rgba(99,179,237,0.2)', borderRadius:10, padding:'14px 16px' }}>
                    <div style={{ color:'#63b3ed', fontSize:'0.72rem', fontWeight:800, letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:10 }}>📨 Envoyer le rapport de sécurité</div>
                    <div style={{ fontSize:'0.75rem', color:'#555', marginBottom:10, lineHeight:1.5 }}>
                      Le courriel inclura toutes les failles détectées avec les risques et corrections, ainsi qu'une offre de service professionnelle d'Ucreative.
                    </div>
                    <div style={{ display:'flex', gap:8 }}>
                      <input
                        type="email"
                        placeholder="courriel@entreprise.com"
                        value={auditEmail[lead.id] || ''}
                        onChange={e => setAuditEmail(prev => ({ ...prev, [lead.id]: e.target.value }))}
                        onKeyDown={e => e.key === 'Enter' && sendAudit(lead)}
                        style={{ flex:1, background:'#0a0a0d', border:'1px solid rgba(99,179,237,0.2)', borderRadius:7,
                          padding:'9px 12px', color:'#EAEAEA', fontSize:'0.82rem', outline:'none' }}
                      />
                      <button onClick={() => sendAudit(lead)}
                        disabled={auditSending.has(lead.id) || !auditEmail[lead.id]?.trim()}
                        style={{ background: auditSending.has(lead.id) ? '#111' : '#63b3ed',
                          color: auditSending.has(lead.id) ? '#333' : '#000',
                          border:'none', borderRadius:7, padding:'9px 16px', cursor: auditSending.has(lead.id) ? 'default' : 'pointer',
                          fontWeight:800, fontSize:'0.8rem', whiteSpace:'nowrap' }}>
                        {auditSending.has(lead.id) ? '⏳ Envoi...' : '📨 Envoyer'}
                      </button>
                    </div>
                  </div>
                )}

                {/* Pitch IA */}
                {showPitch.has(lead.id) && pitches[lead.id] && (
                  <div style={{ margin:'0 18px 12px', background:'#080810', border:'1px solid rgba(139,92,246,0.2)', borderRadius:10, overflow:'hidden' }}>
                    <div style={{ padding:'10px 14px', borderBottom:'1px solid rgba(139,92,246,0.1)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                      <span style={{ color:'#a78bfa', fontSize:'0.72rem', fontWeight:800, letterSpacing:'0.08em', textTransform:'uppercase' }}>✨ Pitch généré par IA</span>
                      <button onClick={() => { navigator.clipboard?.writeText(pitches[lead.id]); setCopied('pitch-' + lead.id); setTimeout(() => setCopied(null), 2000); }}
                        style={{ background:'transparent', border:'1px solid rgba(139,92,246,0.25)', color: copied === 'pitch-' + lead.id ? '#4ade80' : '#a78bfa',
                          padding:'3px 10px', borderRadius:5, cursor:'pointer', fontSize:'0.7rem', fontWeight:600, transition:'color 0.15s' }}>
                        {copied === 'pitch-' + lead.id ? '✓ Copié' : 'Tout copier'}
                      </button>
                    </div>
                    <div style={{ padding:'14px 16px', whiteSpace:'pre-wrap', fontSize:'0.78rem', color:'#888', lineHeight:1.75, maxHeight:340, overflowY:'auto' }}>
                      {pitches[lead.id]}
                    </div>
                  </div>
                )}

                {/* Devis IA */}
                {showProposal.has(lead.id) && proposals[lead.id] && (() => {
                  const p = proposals[lead.id];
                  const urgencyColor = { critique:'#f87171', élevée:'#fbbf24', moyenne:'#60a5fa' };
                  return (
                    <div style={{ margin:'0 18px 12px', background:'#08080f', border:'1px solid rgba(200,255,0,0.18)', borderRadius:10, overflow:'hidden' }}>
                      {/* Header */}
                      <div style={{ padding:'12px 16px', borderBottom:'1px solid rgba(200,255,0,0.1)', display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
                        <div>
                          <div style={{ color:'#C8FF00', fontSize:'0.72rem', fontWeight:800, letterSpacing:'0.08em', textTransform:'uppercase' }}>📋 Devis IA — Proposition commerciale</div>
                          <div style={{ color:'#444', fontSize:'0.7rem', marginTop:2 }}>{lead.name}</div>
                        </div>
                        <div style={{ display:'flex', gap:6, alignItems:'center' }}>
                          {p.validite && <span style={{ background:'rgba(200,255,0,0.07)', border:'1px solid rgba(200,255,0,0.2)', color:'#C8FF00', fontSize:'0.63rem', fontWeight:700, padding:'2px 8px', borderRadius:4 }}>⏳ Valide {p.validite}</span>}
                          <button onClick={() => exportProposalPDF(lead, p)}
                            style={{ background:'rgba(200,255,0,0.07)', border:'1px solid rgba(200,255,0,0.25)', color:'#C8FF00', padding:'4px 11px', borderRadius:6, cursor:'pointer', fontSize:'0.72rem', fontWeight:700 }}>
                            📄 PDF
                          </button>
                        </div>
                      </div>

                      <div style={{ padding:'16px' }}>
                        {/* Accroche */}
                        {p.accroche && (
                          <div style={{ background:'rgba(200,255,0,0.04)', border:'1px solid rgba(200,255,0,0.12)', borderRadius:8, padding:'12px 14px', marginBottom:14, color:'#EAEAEA', fontWeight:700, fontSize:'0.85rem', lineHeight:1.5 }}>
                            "{p.accroche}"
                          </div>
                        )}

                        {/* Résumé */}
                        {p.resume && (
                          <div style={{ color:'#666', fontSize:'0.78rem', lineHeight:1.7, marginBottom:14 }}>
                            {p.resume}
                          </div>
                        )}

                        {/* Problèmes */}
                        {p.problemes?.length > 0 && (
                          <div style={{ marginBottom:14 }}>
                            <div style={{ fontSize:'0.63rem', fontWeight:800, color:'#444', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:8 }}>Problèmes détectés</div>
                            {p.problemes.map((pb, i) => {
                              const c = urgencyColor[pb.urgence] || '#888';
                              return (
                                <div key={i} style={{ borderLeft:`3px solid ${c}`, paddingLeft:10, paddingTop:6, paddingBottom:6, marginBottom:6, background:`${c}06`, borderRadius:'0 6px 6px 0' }}>
                                  <div style={{ display:'flex', alignItems:'center', gap:7, marginBottom:3 }}>
                                    <span style={{ color:c, fontWeight:700, fontSize:'0.78rem' }}>{pb.titre}</span>
                                    <span style={{ background:`${c}18`, border:`1px solid ${c}30`, color:c, fontSize:'0.58rem', fontWeight:800, padding:'1px 6px', borderRadius:3, textTransform:'uppercase', flexShrink:0 }}>{pb.urgence}</span>
                                  </div>
                                  <div style={{ color:'#555', fontSize:'0.72rem', lineHeight:1.5 }}>{pb.desc}</div>
                                </div>
                              );
                            })}
                          </div>
                        )}

                        {/* Services */}
                        {p.services?.length > 0 && (
                          <div style={{ marginBottom:14 }}>
                            <div style={{ fontSize:'0.63rem', fontWeight:800, color:'#444', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:8 }}>Services recommandés</div>
                            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(200px, 1fr))', gap:8 }}>
                              {p.services.map((sv, i) => (
                                <div key={i} style={{ background:'#0d0d15', border:'1px solid rgba(255,255,255,0.07)', borderRadius:8, padding:'12px 12px' }}>
                                  <div style={{ color:'#EAEAEA', fontWeight:700, fontSize:'0.78rem', marginBottom:4 }}>{sv.nom}</div>
                                  <div style={{ color:'#555', fontSize:'0.7rem', lineHeight:1.45, marginBottom:8 }}>{sv.desc}</div>
                                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:4, flexWrap:'wrap' }}>
                                    <span style={{ color:'#C8FF00', fontWeight:800, fontSize:'0.78rem' }}>{sv.prix}</span>
                                    <span style={{ background:'rgba(255,255,255,0.05)', color:'#555', fontSize:'0.65rem', padding:'2px 7px', borderRadius:4 }}>⏱ {sv.delai}</span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Investissement + ROI */}
                        {p.investissement && (
                          <div style={{ background:'rgba(74,222,128,0.05)', border:'1px solid rgba(74,222,128,0.15)', borderRadius:8, padding:'12px 14px', marginBottom:12, display:'flex', alignItems:'flex-start', gap:12 }}>
                            <div style={{ flex:1 }}>
                              <div style={{ fontSize:'0.6rem', textTransform:'uppercase', letterSpacing:'0.08em', color:'#4ade8088', fontWeight:800, marginBottom:4 }}>Investissement total estimé</div>
                              <div style={{ color:'#4ade80', fontWeight:900, fontSize:'1.1rem' }}>{p.investissement}</div>
                              {p.roi && <div style={{ color:'#666', fontSize:'0.72rem', marginTop:5, lineHeight:1.5 }}>📈 {p.roi}</div>}
                            </div>
                          </div>
                        )}

                        {/* Pourquoi nous */}
                        {p.pourquoi_nous && (
                          <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.06)', borderRadius:7, padding:'10px 12px', marginBottom:12 }}>
                            <div style={{ fontSize:'0.6rem', textTransform:'uppercase', letterSpacing:'0.08em', color:'#444', fontWeight:800, marginBottom:5 }}>Pourquoi nous ?</div>
                            <div style={{ color:'#666', fontSize:'0.73rem', lineHeight:1.6 }}>{p.pourquoi_nous}</div>
                          </div>
                        )}

                        {/* CTA */}
                        {p.prochaine_etape && (
                          <div style={{ background:'rgba(200,255,0,0.06)', border:'1px solid rgba(200,255,0,0.2)', borderRadius:8, padding:'12px 14px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
                            <div style={{ color:'#C8FF00', fontWeight:700, fontSize:'0.82rem' }}>👉 {p.prochaine_etape}</div>
                            {(prefs.agencyPhone || prefs.agencyWebsite) && (
                              <div style={{ color:'#444', fontSize:'0.7rem', flexShrink:0 }}>
                                {prefs.agencyPhone && `📞 ${prefs.agencyPhone}`}
                                {prefs.agencyPhone && prefs.agencyWebsite && '  ·  '}
                                {prefs.agencyWebsite && `🌐 ${prefs.agencyWebsite}`}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {/* Rapport Fiche Google */}
                {showGoogleReport.has(lead.id) && (() => {
                  const items = [
                    !lead.website && {
                      icon:'🌐', title:'Aucun site web lié',
                      impact:'Les entreprises avec un site web reçoivent 25–35% de clics en plus sur leur fiche.',
                      action:'Créer un site web professionnel et le lier à la fiche Google Business.',
                      priority:'critique',
                    },
                    !lead.website?.startsWith('https') && lead.website && {
                      icon:'🔒', title:'Site web sans HTTPS',
                      impact:'Google pénalise les sites non sécurisés dans les résultats de recherche.',
                      action:'Installer un certificat SSL (gratuit via Let\'s Encrypt) pour passer en HTTPS.',
                      priority:'élevée',
                    },
                    lead.reviewCount === 0 && {
                      icon:'⭐', title:'Aucun avis Google',
                      impact:'88% des consommateurs consultent les avis avant de choisir un commerce local.',
                      action:'Lancer une campagne de collecte d\'avis par SMS ou email auprès des clients actuels.',
                      priority:'critique',
                    },
                    lead.reviewCount > 0 && lead.reviewCount < 10 && {
                      icon:'⭐', title:`Trop peu d'avis (${lead.reviewCount} avis)`,
                      impact:'Les fiches avec plus de 10 avis obtiennent 3× plus de clics que celles avec moins.',
                      action:'Automatiser la demande d\'avis après chaque vente ou service rendu.',
                      priority:'élevée',
                    },
                    lead.rating != null && lead.rating < 4.0 && {
                      icon:'📉', title:`Note faible (${lead.rating}/5)`,
                      impact:'Une note sous 4.0 fait fuir 70% des clients potentiels.',
                      action:'Répondre à tous les avis négatifs, résoudre les problèmes soulevés, et booster les avis positifs.',
                      priority:'critique',
                    },
                    lead.photoCount === 0 && {
                      icon:'📸', title:'Aucune photo sur la fiche',
                      impact:'Les fiches avec photos reçoivent 42% de demandes d\'itinéraire et 35% de clics de plus.',
                      action:'Ajouter au moins 10 photos professionnelles (intérieur, extérieur, produits, équipe).',
                      priority:'élevée',
                    },
                    lead.photoCount > 0 && lead.photoCount < 5 && {
                      icon:'📸', title:`Galerie incomplète (${lead.photoCount} photo${lead.photoCount > 1 ? 's' : ''})`,
                      impact:'Les entreprises avec plus de 100 photos reçoivent 5× plus d\'appels.',
                      action:'Enrichir la galerie avec des photos régulières et variées (produits, ambiance, événements).',
                      priority:'moyenne',
                    },
                    !lead.hasHours && {
                      icon:'🕐', title:'Horaires d\'ouverture absents',
                      impact:'Sans horaires, l\'entreprise n\'apparaît pas dans les recherches "ouvert maintenant".',
                      action:'Ajouter les horaires de tous les jours, incluant les jours fériés et les périodes spéciales.',
                      priority:'élevée',
                    },
                    !lead.phone && {
                      icon:'📞', title:'Numéro de téléphone manquant',
                      impact:'Les clients ne peuvent pas appeler directement depuis Google Maps.',
                      action:'Ajouter le numéro de téléphone principal et vérifier qu\'il est à jour.',
                      priority:'élevée',
                    },
                  ].filter(Boolean);

                  const priorityColor = { critique:'#f87171', élevée:'#fbbf24', moyenne:'#60a5fa', faible:'#4ade80' };
                  const score = Math.max(0, 100 - items.reduce((s, it) => s + (it.priority === 'critique' ? 25 : it.priority === 'élevée' ? 15 : 8), 0));

                  return (
                    <div style={{ margin:'0 18px 12px', background:'#06080f', border:'1px solid rgba(99,179,237,0.2)', borderRadius:10, overflow:'hidden' }}>
                      {/* En-tête rapport */}
                      <div style={{ padding:'12px 16px', borderBottom:'1px solid rgba(99,179,237,0.12)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                        <div>
                          <div style={{ color:'#63b3ed', fontSize:'0.72rem', fontWeight:800, letterSpacing:'0.08em', textTransform:'uppercase' }}>📊 Audit Fiche Google Business</div>
                          <div style={{ color:'#444', fontSize:'0.7rem', marginTop:2 }}>{lead.name}</div>
                        </div>
                        <div style={{ textAlign:'right' }}>
                          <div style={{ fontSize:'1.3rem', fontWeight:900, color: score >= 70 ? '#4ade80' : score >= 40 ? '#fbbf24' : '#f87171', lineHeight:1 }}>{score}/100</div>
                          <div style={{ fontSize:'0.6rem', color:'#333', marginTop:2 }}>score de présence</div>
                        </div>
                      </div>

                      {/* Liste des problèmes */}
                      {items.length === 0 ? (
                        <div style={{ padding:'16px', color:'#4ade80', fontSize:'0.82rem' }}>✅ Fiche Google bien complétée — pas d'amélioration évidente.</div>
                      ) : (
                        <div style={{ display:'flex', flexDirection:'column' }}>
                          {items.map((item, i) => (
                            <div key={i} style={{ padding:'12px 16px', borderBottom: i < items.length - 1 ? '1px solid rgba(255,255,255,0.03)' : 'none' }}>
                              <div style={{ display:'flex', alignItems:'flex-start', gap:10, marginBottom:6 }}>
                                <span style={{ fontSize:16, flexShrink:0 }}>{item.icon}</span>
                                <div style={{ flex:1 }}>
                                  <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:3 }}>
                                    <span style={{ color:'#EAEAEA', fontWeight:700, fontSize:'0.8rem' }}>{item.title}</span>
                                    <span style={{ background:`${priorityColor[item.priority]}15`, border:`1px solid ${priorityColor[item.priority]}30`, color:priorityColor[item.priority], fontSize:'0.6rem', fontWeight:800, padding:'1px 6px', borderRadius:4, textTransform:'uppercase', flexShrink:0 }}>{item.priority}</span>
                                  </div>
                                  <div style={{ color:'#555', fontSize:'0.72rem', lineHeight:1.55, marginBottom:5 }}>{item.impact}</div>
                                  <div style={{ background:'rgba(99,179,237,0.05)', border:'1px solid rgba(99,179,237,0.1)', borderRadius:6, padding:'6px 10px' }}>
                                    <div style={{ color:'#63b3ed', fontSize:'0.63rem', fontWeight:800, letterSpacing:'0.06em', textTransform:'uppercase', marginBottom:2 }}>✏️ Action recommandée</div>
                                    <div style={{ color:'#666', fontSize:'0.71rem', lineHeight:1.5 }}>{item.action}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Pied de rapport */}
                      <div style={{ padding:'10px 16px', background:'rgba(99,179,237,0.04)', borderTop:'1px solid rgba(99,179,237,0.08)', display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
                        <div style={{ color:'#63b3edaa', fontSize:'0.7rem', lineHeight:1.5 }}>
                          💡 <strong style={{color:'#63b3ed'}}>Argument de vente :</strong> Ces lacunes sont visibles par tous vos clients potentiels sur Google dès maintenant.
                        </div>
                        <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                          <button onClick={() => exportGoogleReportPDF(lead, items, score)}
                            style={{ background:'rgba(200,255,0,0.07)', border:'1px solid rgba(200,255,0,0.25)', color:'#C8FF00', padding:'5px 12px', borderRadius:6, cursor:'pointer', fontSize:'0.72rem', fontWeight:700 }}>
                            📄 PDF
                          </button>
                          <button onClick={() => {
                            const txt = `AUDIT FICHE GOOGLE — ${lead.name}\n${'─'.repeat(40)}\nScore de présence : ${score}/100\n\n${items.map(it => `${it.icon} ${it.title} [${it.priority.toUpperCase()}]\nImpact : ${it.impact}\nAction : ${it.action}`).join('\n\n')}\n\n─ Rapport généré par ${prefs.agencyName || 'Ucreative Inc.'} —`;
                            navigator.clipboard?.writeText(txt);
                            setCopied('google-' + lead.id);
                            setTimeout(() => setCopied(null), 2500);
                          }}
                            style={{ background:'transparent', border:'1px solid rgba(99,179,237,0.25)', color: copied === 'google-' + lead.id ? '#4ade80' : '#63b3ed', padding:'5px 12px', borderRadius:6, cursor:'pointer', fontSize:'0.72rem', fontWeight:600, transition:'color 0.15s' }}>
                            {copied === 'google-' + lead.id ? '✓ Copié' : '📋 Copier'}
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })()}

                {/* Actions */}
                <div style={{ borderTop:'1px solid rgba(255,255,255,0.04)', padding:'11px 16px',
                  display:'flex', gap:6, flexWrap:'wrap', marginTop:'auto' }}>
                  <a href={lead.mapsUrl} target="_blank" rel="noreferrer"
                    style={{ background:'transparent', border:'1px solid rgba(255,255,255,0.08)',
                      color:'#555', padding:'6px 11px', borderRadius:7, fontSize:'0.73rem',
                      textDecoration:'none', display:'inline-flex', alignItems:'center', gap:4 }}>
                    🗺 Maps
                  </a>
                  {lead.phone && (
                    <button onClick={() => copyPhone(lead)}
                      style={{ background:'transparent', border:'1px solid rgba(255,255,255,0.08)',
                        color: copied === lead.id ? '#4ade80' : '#555',
                        padding:'6px 11px', borderRadius:7, cursor:'pointer', fontSize:'0.73rem', transition:'color 0.15s' }}>
                      {copied === lead.id ? '✓ Copié' : '📞 Copier'}
                    </button>
                  )}
                  {lead.website && (
                    <button onClick={() => detectTech(lead)} disabled={techLoading.has(lead.id)}
                      style={{ background: techs[lead.id] ? 'rgba(251,191,36,0.07)' : 'transparent',
                        border:`1px solid ${techs[lead.id] ? 'rgba(251,191,36,0.25)' : 'rgba(255,255,255,0.08)'}`,
                        color: techs[lead.id] ? '#fbbf24' : '#555',
                        padding:'6px 11px', borderRadius:7, cursor: techLoading.has(lead.id) ? 'default' : 'pointer',
                        fontSize:'0.73rem', transition:'all 0.15s' }}>
                      {techLoading.has(lead.id) ? '⏳' : techs[lead.id] ? `🔍 ${techs[lead.id]?.platform?.name || 'Détecté'}` : '🔍 Tech'}
                    </button>
                  )}
                  {techs[lead.id]?.failles?.length > 0 && (
                    <button onClick={() => setShowSecurity(prev => { const s = new Set(prev); s.has(lead.id) ? s.delete(lead.id) : s.add(lead.id); return s; })}
                      style={{ background: showSecurity.has(lead.id) ? 'rgba(248,113,113,0.1)' : 'transparent',
                        border:`1px solid ${showSecurity.has(lead.id) ? 'rgba(248,113,113,0.35)' : 'rgba(255,255,255,0.08)'}`,
                        color: showSecurity.has(lead.id) ? '#f87171' : '#555',
                        padding:'6px 11px', borderRadius:7, cursor:'pointer',
                        fontSize:'0.73rem', fontWeight: showSecurity.has(lead.id) ? 700 : 400, transition:'all 0.15s' }}>
                      🔐 {techs[lead.id].failles.length} faille{techs[lead.id].failles.length > 1 ? 's' : ''}
                    </button>
                  )}
                  {lead.website && (
                    <button onClick={() => findEmail(lead)} disabled={emailLoading.has(lead.id)}
                      style={{ background: emails[lead.id]?.length > 0 ? 'rgba(99,179,237,0.08)' : 'transparent',
                        border:`1px solid ${emails[lead.id]?.length > 0 ? 'rgba(99,179,237,0.3)' : 'rgba(255,255,255,0.08)'}`,
                        color: emails[lead.id]?.length > 0 ? '#63b3ed' : '#555',
                        padding:'6px 11px', borderRadius:7, cursor: emailLoading.has(lead.id) ? 'default' : 'pointer',
                        fontSize:'0.73rem', transition:'all 0.15s' }}>
                      {emailLoading.has(lead.id) ? '⏳' : emails[lead.id]?.length > 0 ? `📧 ${emails[lead.id].length} email(s)` : '📧 Email'}
                    </button>
                  )}
                  {lead.reasons.length > 0 && (
                    <button onClick={() => setShowPlan(prev => {
                        const s = new Set(prev);
                        s.has(lead.id) ? s.delete(lead.id) : s.add(lead.id);
                        return s;
                      })}
                      style={{ background: showPlan.has(lead.id) ? 'rgba(200,255,0,0.08)' : 'transparent',
                        border:`1px solid ${showPlan.has(lead.id) ? 'rgba(200,255,0,0.25)' : 'rgba(255,255,255,0.08)'}`,
                        color: showPlan.has(lead.id) ? '#C8FF00' : '#555',
                        padding:'6px 11px', borderRadius:7, cursor:'pointer', fontSize:'0.73rem', fontWeight: showPlan.has(lead.id) ? 700 : 400 }}>
                      📋 Plan 100/100
                    </button>
                  )}
                  <button onClick={() => setShowGoogleReport(prev => { const s = new Set(prev); s.has(lead.id) ? s.delete(lead.id) : s.add(lead.id); return s; })}
                    style={{ background: showGoogleReport.has(lead.id) ? 'rgba(99,179,237,0.1)' : 'transparent',
                      border:`1px solid ${showGoogleReport.has(lead.id) ? 'rgba(99,179,237,0.35)' : 'rgba(255,255,255,0.08)'}`,
                      color: showGoogleReport.has(lead.id) ? '#63b3ed' : '#555',
                      padding:'6px 11px', borderRadius:7, cursor:'pointer', fontSize:'0.73rem', fontWeight: showGoogleReport.has(lead.id) ? 700 : 400, transition:'all 0.15s' }}>
                    📊 Fiche Google
                  </button>
                  <button
                    onClick={() => {
                      if (pitches[lead.id]) {
                        setShowPitch(prev => { const s = new Set(prev); s.has(lead.id) ? s.delete(lead.id) : s.add(lead.id); return s; });
                      } else {
                        generatePitch(lead);
                      }
                    }}
                    disabled={pitchLoading.has(lead.id)}
                    style={{ background: showPitch.has(lead.id) ? 'rgba(139,92,246,0.1)' : 'transparent',
                      border:`1px solid ${showPitch.has(lead.id) ? 'rgba(139,92,246,0.35)' : 'rgba(255,255,255,0.08)'}`,
                      color: showPitch.has(lead.id) ? '#a78bfa' : '#555',
                      padding:'6px 11px', borderRadius:7, cursor: pitchLoading.has(lead.id) ? 'default' : 'pointer',
                      fontSize:'0.73rem', fontWeight: showPitch.has(lead.id) ? 700 : 400, transition:'all 0.15s' }}>
                    {pitchLoading.has(lead.id) ? '⏳ IA...' : '✨ Pitch IA'}
                  </button>
                  <button
                    onClick={() => {
                      if (proposals[lead.id]) {
                        setShowProposal(prev => { const s = new Set(prev); s.has(lead.id) ? s.delete(lead.id) : s.add(lead.id); return s; });
                      } else {
                        generateProposal(lead);
                      }
                    }}
                    disabled={proposalLoading.has(lead.id)}
                    style={{ background: showProposal.has(lead.id) ? 'rgba(200,255,0,0.1)' : 'transparent',
                      border:`1px solid ${showProposal.has(lead.id) ? 'rgba(200,255,0,0.35)' : 'rgba(255,255,255,0.08)'}`,
                      color: showProposal.has(lead.id) ? '#C8FF00' : '#555',
                      padding:'6px 11px', borderRadius:7, cursor: proposalLoading.has(lead.id) ? 'default' : 'pointer',
                      fontSize:'0.73rem', fontWeight: showProposal.has(lead.id) ? 700 : 400, transition:'all 0.15s' }}>
                    {proposalLoading.has(lead.id) ? '⏳ IA...' : proposals[lead.id] ? '📋 Devis IA' : '📋 Devis IA'}
                  </button>
                  {techs[lead.id]?.failles?.length > 0 && (
                    <button onClick={() => {
                      setShowAuditInput(prev => { const s = new Set(prev); s.has(lead.id) ? s.delete(lead.id) : s.add(lead.id); return s; });
                      if (!auditEmail[lead.id] && emails[lead.id]?.[0]) {
                        setAuditEmail(prev => ({ ...prev, [lead.id]: emails[lead.id][0] }));
                      }
                    }}
                      style={{ background: auditSent.has(lead.id) ? 'rgba(74,222,128,0.08)' : showAuditInput.has(lead.id) ? 'rgba(99,179,237,0.1)' : 'transparent',
                        border:`1px solid ${auditSent.has(lead.id) ? 'rgba(74,222,128,0.3)' : showAuditInput.has(lead.id) ? 'rgba(99,179,237,0.35)' : 'rgba(255,255,255,0.08)'}`,
                        color: auditSent.has(lead.id) ? '#4ade80' : showAuditInput.has(lead.id) ? '#63b3ed' : '#555',
                        padding:'6px 11px', borderRadius:7, cursor:'pointer',
                        fontSize:'0.73rem', fontWeight: showAuditInput.has(lead.id) ? 700 : 400, transition:'all 0.15s' }}>
                      {auditSent.has(lead.id) ? '✓ Courriel envoyé' : '📨 Envoyer audit'}
                    </button>
                  )}
                  <button onClick={() => !added && addToCRM(lead)} disabled={added}
                    style={{ marginLeft:'auto',
                      background: added ? 'rgba(74,222,128,0.07)' : 'rgba(200,255,0,0.07)',
                      border:`1px solid ${added ? 'rgba(74,222,128,0.25)' : 'rgba(200,255,0,0.25)'}`,
                      color: added ? '#4ade80' : '#C8FF00',
                      padding:'6px 14px', borderRadius:7, cursor: added ? 'default' : 'pointer',
                      fontSize:'0.73rem', fontWeight:700, transition:'all 0.15s' }}>
                    {added ? '✓ Dans le CRM' : '➕ Ajouter au CRM'}
                  </button>
                </div>

              </div>
            );
          })}
        </div>
      )}

      {/* ── ÉTAT VIDE ── */}
      {!loading && results.length === 0 && !error && (
        <div style={{ textAlign:'center', padding:'70px 20px' }}>
          <div style={{ fontSize:52, marginBottom:14 }}>🎯</div>
          <div style={{ fontSize:'1.05rem', color:'#333', fontWeight:700, marginBottom:6 }}>
            Sélectionnez une catégorie et lancez la recherche
          </div>
          <div style={{ fontSize:'0.82rem', color:'#2a2a2a', lineHeight:1.7 }}>
            Les entreprises sont scorées automatiquement sur 100<br/>
            Plus le score est <strong style={{color:'#f87171'}}>bas</strong> → plus elles ont besoin de vos services
          </div>
          <div style={{ display:'flex', justifyContent:'center', gap:24, marginTop:28, flexWrap:'wrap' }}>
            {[
              { c:'#f87171', label:'Score 0–30',  desc:'CHAUD — client idéal pour toi' },
              { c:'#fbbf24', label:'Score 31–60', desc:'TIÈDE — potentiel à convaincre' },
              { c:'#4ade80', label:'Score 61–100',desc:'ÉTABLI — déjà fort en ligne' },
            ].map(t => (
              <div key={t.label} style={{ display:'flex', alignItems:'center', gap:8 }}>
                <div style={{ width:10, height:10, borderRadius:'50%', background:t.c }} />
                <div>
                  <div style={{ color:t.c, fontWeight:700, fontSize:'0.78rem' }}>{t.label}</div>
                  <div style={{ color:'#2a2a2a', fontSize:'0.72rem' }}>{t.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      </>)}

    </div>
  );
}
